import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { insh, sto, premiA } from "../../../../Context/InshData";
import { getLS } from "../../../../utils/useLS";
import { transToSal } from "../../../../Context/Local";
import { inshF } from "../../../../Context/InshFront";
import moment from "moment";
import PropTypes from "prop-types";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Zoom from "@material-ui/core/Zoom";
import { useHistory, useLocation } from "react-router-dom";
import dataF from "../../../../Server/dataF.json";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AppBar from "@material-ui/core/AppBar";
import Slide from "@material-ui/core/Slide";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
    createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Fab from "@material-ui/core/Fab";

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

// ===================================================== btn load
import clsx from "clsx";
import Hidden from "@material-ui/core/Hidden";
import {
    useStylesUp,
    useStylesAuto,
    useStylesTF,
    useStylesTD,
    useStylesBA,
    useStylesFU,
    useStylesCAB,
    useStylesLbl,
    SaleCheckbox,
    useStylesDSM,
    useStylesDPM,
    useStylesSN,
} from "../../../../St/comps/UseStyle";

import { stElemnt } from "../../../../St/comps/cStyle";
import "../../../../St/comps/csStyle.css";
import BackdropScI from "../../../../services/BackdropScI";
import ReConnect from "../../../../Start/ReConnect";
import { getInveTypeIndex } from "../../../../modules/utils";
import { getDefaultOmla } from "../../../../services/omlat-services";
import CustomersDialog from "../../../Customers/customers/customersDialog";
import ItemsDialog from "../../../bascDatas/Tab1/items/AddItems/ItamsDialog";
import { useTranslation } from "react-i18next";
import { Box, colors, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@material-ui/core";
import { handleDirectPrintRest, openDrawer } from "../components/printSerivce";
import ExtVoucherDialog from "../components/ExtVoucherDialog";
import { useLocalStorage } from "react-use";
import PaidWindowForm from "../components/paidwidow/paidwindowform";
import CustomerDialogData from "../../../Customers/customers/CustomerDialogData";
import toast from "react-hot-toast";
import RestFooter from "./RestFooter";
import RestAppBar from "./RestAppBar";
import InvoiceRestTable from "./InvoiceRestTable";
import SearchInvoiceScreean, { defualtValueSearch } from "../models/search-model/SearchInvoiceScreean";
import i18next from "i18next";
import OutstandingInvoice from "../models/Outstanding/OutstandingInvoice";
import { RestProductsG } from "./RestProductsG";
import RestHeader from "./RestHeader";
import "./Styleclick.css"
import { ProductsGroups } from "../POS/ProductsGroups";
import { handleInputSearchCustomers, viewHandleCustomers } from "../components/SearchItemsFunction";
import GetTawla from "../models/GetTawla/GetTawla";
import InvoiceTypePrintA4 from "../models/InvoiceTypePrintA4";
import { selectDateOrTime } from "../../../../services/saleAnalysis-services";
import UnitsFilters from "./UnitsFilters";

//=====================================================================
let nevEve = "always",
    nl = null;

const useStylestolb = makeStyles((theme) => ({
    toolbarWrapper: {
        "& .MuiToolbar-gutters": {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

let LetvalueCurrUnits = null;
let group_printer_list = [];
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            keepMounted

        >
            {value === index && (
                <Box >
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
export default function InvoiceRestClass(props) {
    const cl = (c) => {
        console.log(c);
    };
    const { AutoOptions, isPurches, isStock, isMake, isDialog, fromInv } = props;
    const isSavingRef = useRef(false);
    const [showSc, setShowSc] = useState(true);
    const [permistionInv, setPermistionInv] = useState(AutoOptions.permsInvs);
    const [isClick, setIsClick] = useState(insh.ished);
    const [ished, setIshed] = useState(insh.ished);
    const [openPrint, setOpenPrint] = useState({ open: false, localInv: {}, invType: 1, invKind: 1 });
    const clasup = useStylesUp();
    const clasBA = useStylesBA();
    const clasFu = useStylesFU();
    const clasCAB = useStylesCAB();
    const clasSN = useStylesSN();
    const clasAo = useStylesAuto();
    const claslbl = useStylesLbl();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const clstoolbar = useStylestolb();
    const [gets, setGets] = useState(insh.tbname);
    const [maxShifts, setMaxShifts] = useState(AutoOptions.maxShift.id);
    const [maxOrderNo, setMaxOrderNo] = useState(AutoOptions?.maxOrder?.id);

    const [idata, setIData] = useState(() => {
        return { ...insh.IdataInvs, date: moment(new Date()).format("YYYY-MM-DD") };
    }); //is data in ta
    //is data in ta

    const [allow, setAllow] = useState({ c: false, s: false, it: false, cud: false });
    const [showPaid, setShowPaid] = useLocalStorage("show-paid-window", false);
    const [localCashe, setLocalCashe] = useState([]);
    const [localCasheItems, setLocalCasheItems] = useState([]);

    const [outstandData, setOutstandData] = useState([]);

    /* Anemation */
    const [transition, setTransition] = React.useState(undefined);
    function TransitionUp(props) {
        return <Slide {...props} direction="up" />;
    }
    function TransitionRight(props) {
        return <Slide {...props} direction="right" />;
    }
    function TransitionDown(props) {
        return <Slide {...props} direction="down" />;
    }

    const [isOpenSy, setIsOpenSy] = useState(false);

    const handleOpenSy = () => {
        setAllow({ ...allow, s: true });
        setIsOpenSy(!isOpenSy);
    }; // E rsa

    const filter = createFilterOptions();

    //rsa
    const [isOpenCustomer, setIsOpenCustomer] = useState(false);
    const [isOpenCustomerData, setIsOpenCustomerData] = useState(false);
    const [custData, setCustData] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleOpenCustomerData = () => {
        setAllow({ ...allow, cud: !isOpenCustomerData });
        setIsOpenCustomerData(!isOpenCustomerData);
    }; // E rsa
    const handleOpenCustomer = () => {
        setAllow({ ...allow, c: !isOpenCustomer });
        setIsOpenCustomer(!isOpenCustomer);
    }; // E rsa
    // s Dup
    const backHome = () => {
        his.push({ pathname: "/" });
        window.location.reload(false);
    };

    // s DDown
    const [openDw, setOpenDw] = useState(false);

    const handOpenDw = (Transition) => {
        setTransition(() => Transition);
        getInvs(
            dateFrom + " " + timeFrom,
            dateTo + " " + timeTo,
            null,
            sto.User_typei
        );
        setOpenDw(true);
    };
    const handCloseDw = () => {
        setOpenDw(false);
    };

    const [subInfo, setSubInfo] = useState(insh.InfoSub);
    const [counts, setCounts] = useState({ curr: 0 });
    const [rowUpdate, setRowUpdate] = useState({}); //is data in ta
    const [selectUnit, setSelectUnit] = useState({}); //is data in ta
    const [foundData, setFoundData] = useState({ found: {}, omlat: [], invSet: {} }); //is data in ta

    /* s DcuD  */
    const [openCuD, setOpenCuD] = React.useState(false);
    const [openTawla, setOpenTawla] = React.useState(false);
    const [tawlaGroups, setTawlaGroups] = React.useState([]);

    const [dialog, setDialog] = React.useState(inshF.dia);
    useEffect(() => {
        window.onbeforeunload = function (e) {
            e.preventDefault();
            return "you can not refresh the page";
        };
    }, []);

    const handleClDia = (prop, state) => setDialog({ ...dialog, [prop]: state });
    const [openDwt, setOpenDwt] = useState(false);

    const handOpenDwt = (Transition) => {
        setTransition(() => Transition);
        getInvst(
            dateFrom + " " + timeFrom,
            dateTo + " " + timeTo,
            null,
            sto.User_typei
        );
        setOpenDwt(true);
    };
    const handCloseDwt = () => {
        setOpenDwt(false);
    };
    /* s PMD */
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

    const [openPMD, setOpenPMD] = useState(false);
    const handleClickOpenPMD = (Transition) => {
        setTransition(() => Transition);
        setOpenPMD(true);
    };

    const handClosePMD = async (state) => {
        if (state === "cancle") await restPM(state);
        await setOpenPMD(false);
    };
    /* e PMD */

    /* s BCSD */

    const reLoadCust = async (newCustData) => {
        if (newCustData != null) {
            setOptionsCustomers([newCustData, ...optionsCustomers]);
            setValueCustomers(newCustData);
            changAutoCustomers(newCustData);
        }
    };

    const { t: transForm } = useTranslation(["forms"]);

    /* e BCSD */

    const onSelectRest = (dataCode) => {
        if (permistionInv.SIM == false) {
            const newItem = localCashe.find((obj) => obj.item.barcode.toString() === dataCode.barcode.toString());
            if (newItem && localCashe.length > 0) {
                let totValbef = 0.0;
                for (let m = 0; m < isdata.length; m++) {
                    if (newItem?.item?.curr == isdata[m].currency_from)
                        totValbef += (isdata[m].val1 * isdata[m].val);
                };
                let oldVal = Number(newItem.val) - totValbef;

                setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
                if (permistionInv.SIM == false &&
                    oldVal < 1 && newItem?.item?.ctype != 4 &&
                    (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                    alert(
                        `
                الكمية المدخلة للصنف أكبر من رصيد المخزن
                الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(newItem.item?.perc))
                        }
                رصيد المخزن : ${valueSafes.name} = ${parseInt(newItem?.val)
                        }
                `
                    );
                } else {
                    barcodeadd({ ...newItem?.item }, { ...newItem?.unit }, newItem.units, newItem.val);
                }
            } else {
                getBarcodeMulti(dataCode.barcode);
            }
        } else {
            onSelectRestDownload(dataCode);
        }
    };
    const onSelectRestDownload = (dataCode) => {
        // setRowUpdate({});
        // console.log("the dataCode is", dataCode);
        let pricei = 0.0;
        let totJust = 0.0;
        let taxval = 0.0;
        let taxperc = 0.0;
        let diaperc = 0.0;
        let dismount = 0.0;
        let valperc = 0.0;
        let tot_before_vat_with_tab3val = 0.0;
        if (setting.PrTy_InPr === "22") {
            taxperc = 0.0;
            pricei = parseFloat(dataCode?.purch_price).toFixed(2);
        } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
            pricei = parseFloat(dataCode?.sale_price);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        }
        else {
            pricei = parseFloat(dataCode?.purch_price);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        };
        if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
            if (valueCustomers?.disc_perc > 0) {
                dataCode.discount = valueCustomers?.disc_perc;
                dataCode.amount_disc = 0;
            } else if (valueCustomers?.discount > 0) {
                dataCode.discount = 0;
                dataCode.amount_disc = valueCustomers?.discount;
            }
        }

        taxval = ((parseFloat(pricei) * parseFloat(dataCode.tax)) / 100).toFixed(2);
        totJust = (parseFloat(pricei)).toFixed(2);

        let i = {
            amount_disc: Number(dataCode.amount_disc),
            discount: Number(dataCode.discount),
        };
        diaperc = (parseFloat(i.discount)).toFixed(2);
        dismount = (parseFloat(i.amount_disc)).toFixed(2);
        if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
        // valperc = (parseFloat(dataCode.perc)).toFixed(2);

        let errorList = [];
        let restaxvalA = 0,
            resNetA = 0,

            restotJustSumA = 0,
            restotJustAfterDiscSumA = 0,
            resDiscPerA = 0,
            resDisCountA = 0,
            tot_befor_vat_after_disc = 0;

        restotJustSumA = parseFloat(totJust);

        if (permistionInv.DSOB == true) {
            if (checked.discRateck === true) {
                //  alert('in if')
                resDiscPerA = parseFloat(invDisc.rate);
                resDisCountA = (
                    parseFloat(invDisc.rate / 100) * parseFloat(totJust)
                ).toFixed(2);

                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(resDisCountA);
            } else if (checked.discMinusck === true) {
                resDiscPerA = (
                    (parseFloat(idata.minus) / parseFloat(totJust)) *
                    100
                ).toFixed(2);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(totJust)
                ).toFixed(2);
            }

        } else {
            if (diaperc > 0) {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);
                resDiscPerA = parseFloat(diaperc);
                resDisCountA = (
                    parseFloat(diaperc / 100) * parseFloat(totJust)
                ).toFixed(2);

            } else if (dismount > 0) {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);

                let desc_perc = (
                    (dismount * 100) /
                    parseFloat(totJust)
                );
                resDiscPerA = parseFloat(desc_perc);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(totJust)
                ).toFixed(2);

            } else {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);
                resDiscPerA = parseFloat(diaperc);
                resDisCountA = (
                    parseFloat(diaperc / 100) * parseFloat(totJust)
                ).toFixed(2);
            }

        }



        restotJustAfterDiscSumA =
            parseFloat(totJust) - parseFloat(resDisCountA);


        restaxvalA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "taxval"
        );

        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "before_vat"
        );
        resNetA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "Net"
        );

        if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
                parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

            let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalA = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
        }

        dataCode = {
            /* to show */
            minPrice: dataCode.min_sale_price,
            PricePu: dataCode.purch_price,
            unitame: "unit" /*  - الـوحدة name */,
            symbol: dataCode.symbol /*  - إسم الصنف  */,
            /* to maaths */
            /* int -  الإجمالي */
            totJust: restotJustSumA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,
            sale_price: parseFloat(dataCode?.purch_price),

            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,
            /* to go */
            // currency_from: parseInt(subInfo.id), /* float - id الصنف */
            currency_from: parseInt(dataCode.id) /* float - id الصنف */,
            unit: parseInt(dataCode.unit) /* int - الـوحدة id */,
            /* float - الكمية */
            val1: parseFloat(1),
            // new _val1:parseFloat(subInfo.new _val1),
            /* float - العبوة */
            val: parseFloat(1),
            // new _val:parseFloat(subInfo.perc),
            /* float - الـسعر */
            new_exchange_price: parseFloat(pricei),
            // all_new_exchange_price: parseFloat(subInfo.Price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountA,
            /* float - %  خصم نسبة */
            DiscPers: resDiscPerA,
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(taxperc),
            /* float - إجمالي قيمة المضافة  */
            taxval: parseFloat(restaxvalA),
            netAmountSub: parseFloat(resNetA).toFixed(2),
            barcode: dataCode.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,
            unitame: dataCode.unitName,
            sale_price: parseFloat(dataCode.sale_price),
            discount: resDisCountA,
            DiscPers: resDiscPerA,
            taxperc: parseFloat(taxperc),
            Qtys: 0,
            UnitsTable: dataCode?.units ?? [],
            defUnit: {},
            no: isdata?.length,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            type: dataCode.type,
        };
        if (errorList.length < 1) {
            //no error
            let add = 0;

            const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
                && obj.new_exchange_price === dataCode.new_exchange_price);

            if (permistionInv?.NOREP === true) {
                let dataToAdd = [...isdata];
                dataToAdd.push(dataCode);
                setIsData(dataToAdd);
                handSums(dataToAdd);
                setExSub(dataToAdd.length);
                add = 1;
                setRowUpdate(dataCode);
            }
            else {
                if (updateItem?.no != null) {
                    let add = 1;
                    let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
                    if (!isNaN(multiplier)) {

                        let tot = parseFloat(multiplier * updateItem.new_exchange_price);
                        let desc_mount = (
                            parseFloat(tot) *
                            (updateItem.DiscPers / 100)
                        );
                        let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

                        let taxMount = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "taxval"
                        );
                        let betTax = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "before_vat"
                        );

                        let resNetA = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "Net"
                        );

                        if (parseFloat(updateItem?.tab3val_sub) > 0) {
                            let tot_before_new = maths(
                                parseFloat(pricei),
                                parseFloat(updateItem.taxperc),
                                "before_vat"
                            );
                            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

                            let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                            taxMount = mathsTab3val(
                                parseFloat(tot_before),
                                parseFloat(updateItem.taxperc),
                                "taxval"
                            );

                            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                                + parseFloat(taxMount)).toFixed(2);
                        }
                        const newData = {
                            ...updateItem,
                            val1: multiplier,
                            totJust: tot,
                            totAfterDisc: betTax,
                            taxval: taxMount,
                            netAmountSub: resNetA,
                            discount: desc_mount,
                            tab3val_sub: tot_before_vat_with_tab3val,
                            tab3Val: tot_before_vat_with_tab3val,
                        };

                        const index = updateItem?.no;
                        const dataUpdate = [...isdata];
                        dataUpdate[index] = { ...newData };
                        setIsData([...dataUpdate]);
                        handSums(dataUpdate);
                        setRowUpdate(updateItem);
                    }
                } else {
                    let dataToAdd = [...isdata];
                    dataToAdd.push(dataCode);
                    setIsData(dataToAdd);
                    handSums(dataToAdd);
                    setExSub(dataToAdd.length);
                    add = 1;
                    setRowUpdate(dataCode);
                }

            }
        } else {
            // resolve();
        }
        if (permistionInv?.SHOW_UNITS && dataCode?.UnitsTable?.length > 0) {
            setSelectUnit(dataCode?.UnitsTable[0]);
        }

    };
    const changAutoCurrUnits = (newValue) => {
        setSelectUnit(newValue);
        let prc = setting.cusType == 1 ? newValue.sale : newValue.purch;
        let tot = (parseFloat(prc) * parseFloat(rowUpdate.val1));
        let desc_mount = (
            parseFloat(tot) *
            (rowUpdate.DiscPers / 100)
        );
        let totbef = (parseFloat(tot) - parseFloat(desc_mount));

        let taxMount = maths(
            parseFloat(totbef),
            parseFloat(rowUpdate.taxperc),
            "taxval"
        );
        let betTax = maths(
            parseFloat(totbef),
            parseFloat(rowUpdate.taxperc),
            "before_vat"
        );

        let resNetA = maths(
            parseFloat(totbef),
            parseFloat(rowUpdate.taxperc),
            "Net"
        );
        let tot_before_vat_with_tab3val = 0;
        if (parseFloat(rowUpdate?.tab3val_sub) > 0 && parseFloat(rowUpdate.taxperc) > 0 && permistionInv?.USETOBACO) {
            let tot_before_new = maths(
                parseFloat(prc),
                parseFloat(rowUpdate.taxperc),
                "before_vat"
            );
            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * rowUpdate.val1) : parseFloat(betTax).toFixed(2);

            let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(rowUpdate.taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
        }
        let val1 = rowUpdate.val1 == 0 ? 1 : rowUpdate.val1;
        let itemType = Number(rowUpdate?.type);

        let subInfoVal1_perc = rowUpdate.val1 * newValue.perc;
        let countsCurr = parseInt(rowUpdate?.Qtys ?? 0) - parseInt(val1);
        if (permistionInv.SIM == false &&
            countsCurr < subInfoVal1_perc && itemType != 4 &&
            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
            const index = rowUpdate?.no;
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                time: 2000,
            });
        } else {
            const index = rowUpdate?.no;
            const dataUpdate = [...isdata];
            const updateRow = {
                ...rowUpdate,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                new_exchange_price: setting.cusType == 1 ? newValue.sale : newValue.purch,
                exchange_price: setting.cusType == 1 ? newValue.sale : newValue.purch,
                perc: newValue.perc,
                PricePu: newValue.purch,
                unitame: newValue.unitName,
                unit: newValue.unit,
                val: newValue.perc,
                defUnit: newValue,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
                editAbleUnit: false,
            };
            dataUpdate[index] = updateRow;
            setRowUpdate(updateRow);
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
        }
    };
    const onSelectNumber = (rowN) => {
        let valQ = Number(rowN.value);
        console.log("the valQ is", valQ)

        if (valQ === 10) {
            if (rowUpdate?.no !== null) {
                var newData = isdata.filter((obj) => obj.no !== rowUpdate.no);
                const newItems = newData.map((row, i) => {
                    return {
                        ...row,
                        no: i,
                    };
                });
                setIsData([...newItems]);
                handSums(newData);
                setRowUpdate({});
            }
        } else if (valQ === 11) {
            const dataUpdate = [];
            setIsData([]);
            handSums(dataUpdate);
        } else {
            if (rowUpdate?.no !== null) {

                let tot = parseFloat(valQ * rowUpdate.new_exchange_price);

                let desc_mount = (
                    parseFloat(tot) *
                    (rowUpdate.DiscPers / 100)
                );

                let totBe = parseFloat((valQ * rowUpdate.new_exchange_price) - desc_mount);

                let taxMount = maths(
                    parseFloat(totBe),
                    parseFloat(rowUpdate.taxperc),
                    "taxval"
                );
                let betTax = maths(
                    parseFloat(totBe),
                    parseFloat(rowUpdate.taxperc),
                    "before_vat"
                );

                let resNetA = maths(
                    parseFloat(totBe),
                    parseFloat(rowUpdate.taxperc),
                    "Net"
                );
                let tot_before_vat_with_tab3val = 0;
                if (parseFloat(rowUpdate?.tab3val_sub) > 0) {
                    let tot_before_new = maths(
                        parseFloat(rowUpdate.new_exchange_price),
                        parseFloat(rowUpdate.taxperc),
                        "before_vat"
                    );
                    tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                        (parseFloat(25) * valQ) : parseFloat(betTax).toFixed(2);

                    let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                    taxMount = mathsTab3val(
                        parseFloat(tot_before),
                        parseFloat(rowUpdate.taxperc),
                        "taxval"
                    );

                    resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                        + parseFloat(taxMount)).toFixed(2);
                }

                // let countsCurr = Number(rowUpdate?.Qtys) - Number(totValbef);
                const newData = {
                    ...rowUpdate,
                    val1: valQ,
                    totJust: tot,
                    totAfterDisc: betTax,
                    taxval: taxMount,
                    netAmountSub: resNetA,
                    discount: desc_mount,
                    tab3val_sub: tot_before_vat_with_tab3val,
                    tab3Val: tot_before_vat_with_tab3val,
                };

                const index = rowUpdate?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = { ...newData };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);

            }
        }

    };
    const [lbl, setLbl] = React.useState(insh.Lbl);
    const [switchState, setSwitchState] = React.useState(insh.SwitchState);

    const chashVSnetwork = (valChecked) => {

        if (valChecked == true && valueType.id !== 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

            setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id });
        } else if (valChecked == false && valueType.id !== 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true, stock: false });
            setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

        } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });

        }
        else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });

        }
    };
    const changClick = (prop, ev) => {
        if (prop == "minus") setUiElement({ ...uiElement, [prop]: ev, rate: true });
        else if (prop == "rate")
            setUiElement({ ...uiElement, [prop]: ev, minus: true });
    };

    const changSwitch = (name) => (event) => {
        setSwitchState({ ...switchState, [name]: event.target.checked });

        if (name == "cashORnetworksw") chashVSnetwork(event.target.checked);
    };

    const handleCloseCuDWithSWState = () => {
        switchState.stayInDCurr ? setOpenCuD(true) : setOpenCuD(false);
        setSubInfo(insh.InfoSub);
    };

    const changChckedPM = (network, agel, bank, emp, onlyCheked) => {
        onlyCheked === ""
            ? setChecked({
                ...checked,
                network_partck: network,
                agel_partck: agel,
                bank_partck: bank,
                emp_partck: emp,
            })
            : setUiElement({ ...uiElement, [onlyCheked]: false });
    };

    const changAutosPM = (bank, bank2, emp, onlyCheked) => {
        if (onlyCheked === "") {
            if (bank === false) setValueBankPMD(insh.AutoBank);
            if (bank2 === false) setValueBankTransPMD(insh.AutoBank);
            if (emp === false) setValueEmployePMD(insh.Auto);
            setUiElement({
                ...uiElement,
                bankPM: !bank,
                bankPM2: !bank2,
                empPM: !bank,
            });
        } else {
            if (onlyCheked === "bankPM") setValueBankPMD(insh.AutoBank);
            else if (onlyCheked === "bankPM2") setValueBankTransPMD(insh.AutoBank);
            else if (onlyCheked === "empPM") setValueEmployePMD(insh.Auto);
            setUiElement({ ...uiElement, [onlyCheked]: true });
        }
    };

    const restPM = (from) => {
        let ck = { network: true, agel: true, bank: true, emp: true };
        if (from === "rest") {
            if (idata.network_part === "") ck.network = false;
            if (idata.agel_part === "") ck.agel = false;
            if (idata.bank_part === "") ck.bank = false;
            if (idata.emp_part === "") ck.emp = false;
        } else {
            ck.network = false;
            ck.agel = false;
            ck.bank = false;
            ck.emp = false;
        }
        changChckedPM(ck.network, ck.agel, ck.bank, ck.emp, "");
        changAutosPM(ck.network, ck.bank, ck.emp, "");
    };

    const [or, setOr] = useState(insh.Or);
    const [permiCuCo, setPrmiCuCo] = useState({});
    let typePress = "save";
    let openPay = false;
    const getPrmetions = (resDataElm, permiCuCo) => {
        console.log("permisttion is ", permiCuCo);
        getAutoPricePays(permiCuCo.TSP);
        if (permistionInv.USP) {
            nevEve = "never";
        }

        setPrmiCuCo(permiCuCo);
    };

    const [uiElement, setUiElement] = useState({});

    // >>>>> datas
    const [currencies, setCurrencies] = useState([]);
    const [invsShow, setInvsShow] = useState([]);
    const [invsShowt, setInvsShowt] = useState([]);
    const [exsub, setExSub] = useState(0);
    const [invsShowFltr, setInvsShowFltr] = useState([]);

    const [infoInv, setInfoInv] = useState({ id: "", InvId_Return: "" });

    const [isdata, setIsData] = useState([]); //is data in ta

    const location = useLocation();

    const [stor, setStor] = useState({}); //is data in ta
    const [storS, setStorS] = useState({}); //is data in ta

    const [favGroups, setFavGroups] = useState([]);
    const [groups, setGroups] = useState([]);
    const [groupsSub, setGroupsSub] = useState([]);

    // Auto

    const [auto, setAuto] = useState(insh.auto);

    const [valueType, setValueType] = useState(insh.Auto);

    //TypeInvs
    const [valueTypeFltr, setValueTypeFltr] = useState(insh.Auto);
    //Safes
    const [valueSafes, setValueSafes] = useState(insh.Auto);
    //Customers
    const [optionsCustomers, setOptionsCustomers] = useState(AutoOptions?.Customers);
    const countCustomers = AutoOptions?.Customers?.length === 250 ? true : false;
    const [valueCustomers, setValueCustomers] = useState(AutoOptions.Customers[0]);
    const [searchCustText, setSearchCustText] = useState("");

    //Salesmen
    const [valueSalesmen, setValueSalesmen] = useState(insh.Auto);
    //Employee
    const [valueEmployePMD, setValueEmployePMD] = useState(insh.Auto);
    //Costcenter
    const [valueCostcenter, setValueCostcenter] = useState(insh.Auto);
    //Stock
    const [valueStock, setValueStock] = useState(insh.Auto);
    const [omlaValue, setOmlaValue] = useState(insh.Auto);
    // network
    const [valueBank, setValueBank] = useState(insh.AutoBank);
    // network PMD
    const [valueBankPMD, setValueBankPMD] = useState(insh.AutoBank);
    const [valueBanksPaid, setValueBanksPaid] = useState(insh.AutoBank);
    //Bank Trans PMD
    const [valueBankTransPMD, setValueBankTransPMD] = useState(insh.AutoBank);
    //Units

    const [countCurrBySafe, setCountCurrBySafe] = useState([]);
    const [procIdSearch, setProcIdSearch] = useState(0);
    const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
    const [value, setValue] = React.useState(0);

    const [currenciesToInv, setCurrenciesToInv] = useState([]);
    const [currUnit, setCurrUnit] = useState([]);
    const [currUnitsAll, setCurrUnitsAll] = useState([]);
    const [optionsCurrUnits, setOptionsCurrUnits] = useState(insh.AutoOp);
    const [valueCurrUnits, setValueCurrUnits] = useState(insh.Auto);
    const [indexUnit, setIndexUnit] = useState(0);
    //PricePay
    const [optionsPricePay, setOptionsPricePay] = useState(insh.AutoOp);
    const [valuePricePay, setValuePricePay] = useState(insh.Auto);
    // edrees changes
    const [itemId, setItemId] = useState("1");
    const [barcodes_eds, setBarcodes_eds] = useState();

    const handleFocus = (e) => e.target.select();
    const getAutoPricePays = (i) => {
        setOptionsPricePay(insh.optionPricePay);
        setValuePricePay(insh.optionPricePay[i]);
    };

    const addChangds = () => {
        idata.date =
            moment(idata.date).format("YYYY-MM-DD") +
            moment(new Date()).format(" h:mm A");
        idata.InvId_Return = infoInv.InvId_Return;
    };

    const getInvs = async (from, to, type, utype) => {
        if (type == null) {
            await axios
                .get(
                    uri +
                    "InvDate" +
                    `?id=${sto.empi}&&dateF=${from}&&dateT=${to}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&branch=${sto.branchi}`
                )
                .then((res) => {
                    cl("===res.data");
                    cl(res.data);
                    setInvsShow(res.data);
                    setInvsShowFltr(res.data);
                })
                .catch((error) => { });
        } else {
            await axios
                .get(
                    uri +
                    "InvDate" +
                    `?id=${sto.empi}&&dateF=${from}&&dateT=${to}&&itype=${type}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&branch=${sto.branchi}`
                )
                .then((res) => {
                    cl("===res.data");
                    cl(res.data);
                    setInvsShow(res.data);
                    setInvsShowFltr(res.data);
                })
                .catch((error) => { });
        }
    };

    const getInvst = async (from, to, type, utype) => {
        if (type == null) {
            await axios
                .get(
                    uri +
                    "InvDatet" +
                    `?id=${sto.empi}&&dateF=${from}&&dateT=${to}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&bran=${sto.branchi}`
                )
                .then((res) => {
                    cl("===res.data");
                    cl(res.data);
                    setInvsShowt(res.data);
                    setInvsShowFltr(res.data);
                })
                .catch((error) => { });
        } else {
            await axios
                .get(
                    uri +
                    "InvDatet" +
                    `?id=${sto.empi}&&dateF=${from}&&dateT=${to}&&itype=${type}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&bran=${sto.branchi}`
                )
                .then((res) => {
                    cl("===res.data");
                    cl(res.data);
                    setInvsShow(res.data);
                    setInvsShowFltr(res.data);
                })
                .catch((error) => { });
        }
    };

    const fltringCurrencieToinv = async (res, pricePayId, changtaxperc) => {
        if (setting.PrTy_InPr == "22") res.tax = 0;
        let sORp = 0;
        if (setting.cusType == 1) sORp = res.sale;
        else if (setting.cusType == 2) sORp = res.purch;
        if (changtaxperc == false) {
            res.tax = subInfo.taxperc;
            res.val1 = subInfo.val1;
        }
        if (pricePayId == 2) sORp = res.dPrice;
        else if (pricePayId == 3) sORp = res.jPrice;
        if (checked.autoOrStaticck === false) {
            setSubInfo({
                ...subInfo,
                hdshw: true,
                val1: res.val1,
                id: res.id,
                minPrice: res.mPrice,
                Price: sORp,
        /*PricePu:res.purch,*/ barcode: res.barcode,
                symbol: res.symbol,
                type: res.type,
                perc: res.perc,
                taxperc: res.tax,
                totJust: (sORp * res.val1).toFixed(2),
                discount: "",
                DiscPers: "",
                taxval: ((sORp * res.tax) / 100).toFixed(2),
                is_tab3_curr: res?.is_tab3_curr,

            });
        } else {
            subInfo.hdshw = true;
            subInfo.val1 = res.val1;
            subInfo.id = res.id;
            subInfo.Price = sORp;
            subInfo.minPrice = res.mPrice;
            subInfo.barcode = res.barcode;
            subInfo.symbol = res.symbol;
            subInfo.perc = res.perc;
            subInfo.taxperc = res.tax;
            subInfo.totJust = (sORp * res.val1).toFixed(2);
            subInfo.discount = "";
            subInfo.DiscPers = "";
            subInfo.type = res.type;
            subInfo.taxval = ((sORp * res.tax) / 100).toFixed(2);
            subInfo.is_tab3_curr = res?.is_tab3_curr;

        }
    };

    const reLoadLastInv = async () => {
        const tb = {
            other: true,
            MaxOrderNo: true,
            parms: {
                sProcTypeInvProc: setting.PrTy_InPr,
                branch: sto.branchi,
                tname: "invs",
            },
            autos: {},
        };
        await axios
            .post(uri + "Res", tb)
            .then((res) => {
                setInfoInv({ id: res.data.other.lastid, InvId_Return: "" });
                setMaxOrderNo(res.data?.maxOrder?.id ?? 0);
            })
            .catch((error) => { });
    };

    const loadSto = async (cusType) => {
        const locSto = getLS("sto", {});
        setGets(locSto);
        console.log("the log sto is", locSto);
        // eds changed
        // setBarcodes_eds(locSto.Currencies.map((c) => c.barcode));
        // setBarcodes_eds(AutoOptions?.Items.map((c) => c.barcode));
        setPermistionInv(AutoOptions.permsInvs);

        /* go Func we need check Condsh */
        let valCust = AutoOptions.Customers[0];

        // loadIdata(valCust, locSto.types, locSto?.Banks);
        loadIdata(AutoOptions.Customers[0], AutoOptions.types, AutoOptions?.Banks);

        // const safe = getSafeDefault(locSto.permisApp.user_id, locSto.Users);

        setValueSafes(AutoOptions.Safes[0]);
        setValueStock(AutoOptions.Stocks[0]);
        const defOmla = getDefaultOmla(locSto.omlats);
        setOmlaValue(defOmla);
        setOptionsCustomers(AutoOptions.Customers);
        setValueCustomers(AutoOptions.Customers[0]);
        // setCurrencies(locSto.Currencies);
        setCurrencies(AutoOptions.Items);

        setcuRows(
            // locSto.Currencies?.map((c) => {
            AutoOptions.Items?.map((c) => {

                return { ...c, sale_price: c.sale_price * defOmla.exchange };
            })
        );
        setGroups(AutoOptions.groups);
        setFavGroups(AutoOptions.Items);
        setCurrenciesToInv(AutoOptions.Items);
        const inveTypeIndex = getInveTypeIndex(valCust.Cust_inv_type);
        setValueTypeFltr(locSto.typesFltr[0]);
        getCustInvType(AutoOptions.Customers[0]);
    };


    const getCustInvType = (valCust) => {
        setUiElement(insh.UiElement);

        let kind_inv = 2;
        let locR = getLS("DataRem", {});

        const locSto = getLS("sto", {});



        if (AutoOptions.Customers[0].Cust_inv_type != null) {
            if (AutoOptions.Customers[0].Cust_inv_type == 0 || AutoOptions.Customers[0].Cust_inv_type == 2) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);

                setPayment({ ...payment, paidup: 0, stay: 0 });

                setValueStock(AutoOptions.Stocks[0]);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });
                setIData({
                    ...location.state.idata,
                    inv_type: 2,
                    pay_type: 1,
                    bank: 0,
                    cust_id: valCust.id,
                    stock: AutoOptions.Stocks[0].id,
                    customer_name: valCust.name,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    date: moment(new Date()).format("YYYY-MM-DD")
                });
                //setOptionsBank(insh.AutoBankOp);
                setValueType(AutoOptions.types[1]);


            } else if (AutoOptions.Customers[0].Cust_inv_type === 1) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: true,
                    bank: true,
                });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...location.state.idata,
                    inv_type: 1, pay_type: -1, bank: -1,
                    cust_id: valCust.id,
                    customer_name: valCust.name,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    date: moment(new Date()).format("YYYY-MM-DD")
                });
                setValueType(AutoOptions.types[0]);

            }
            else if (AutoOptions.Customers[0].Cust_inv_type === 3 || AutoOptions.Customers[0].Cust_inv_type === 4) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: false,
                });
                setValueStock(AutoOptions.Stocks[0]);
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setPayment({ ...payment, paidup: 0, stay: 0 });
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: 0 });
                setSwitchState({ ...switchState, cashORnetworksw: true });
                const text = transForm("network").toString();
                setLbl({ ...lbl, chashNetwork: text });


                setIData({
                    ...location.state.idata,
                    inv_type: 2,
                    pay_type: 2,
                    branch: sto.branchi,
                    sales_emp: sto.empi,
                    create_user: sto.idi,
                    bank: AutoOptions.Banks[0].id,
                    cust_id: AutoOptions.Customers[0].id,
                    customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
                });
                setValueType(AutoOptions.types[1]); //getAutobanks(0);
            }
        } else {
            setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({
                ...uiElement,
                stock: false,
                payMethod: false,
                bank: true,
            });
            setSwitchState({ ...switchState, cashORnetworksw: false });
            setIData({
                ...location.state.idata, inv_type: 2,
                branch: locR.branchi,
                stock: AutoOptions.Stocks[0].id,
                sales_emp: sto.empi,
                create_user: locR.idi,
                pay_type: 1, bank: 0, cust_id: valCust.id,
                customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
            });

            setValueType(AutoOptions.types[1]);

        }
    }
    const loadGet = async (branch, pTpI, empid, formid, invType) => {
        setInfoInv({ ...infoInv, id: AutoOptions.other?.lastid });
        getPrmetions(AutoOptions.permisElm, AutoOptions.permiCuCo);
        setShowSc(AutoOptions.wait?.state);
    };


    // const location = useLocation();
    const [setting, setSetting] = useState({});
    const [style, setStyle] = useState({});

    const loadInsh = async () => {
        setSetting(location.state.setting);

        // setIData(l_ocation.state.idata);
        setStor(location.state.stor);
        loadGet(
            location.state.idata.branch,
            location.state.setting.PrTy_InPr,
            location.state.idata.create_user,
            location.state.setting.iformid,
            location.state.stor.invsType
        );
        loadSto(location.state.setting.cusType);
        setStorS(location.state.setting.stors);

        setStyle(location.state.style);
    };

    let setupReload = function () {
        // for update date in midnight
        const timeUntilMidnight = moment()
            .endOf("day")
            .add(10, "ms")
            .diff(moment(), "ms");
        return setTimeout(function () {
            setIData({ ...idata, date: moment(new Date()).format("YYYY-MM-DD") });

            setupReload();
        }, timeUntilMidnight);
    };

    /* =============================== */
    useEffect(() => {
        loadInsh();
        setupReload();
    }, []);

    /* =============================== */

    const toDoIdata = (prop, value) => {
        setIData({ ...idata, [prop]: value });
    };
    const reInshAuto = (id, name) => {
        if (id == null && name == "") return insh.Auto;
        else return { id: id, name: name };
    };

    const loadIdata = (valCust, locStoTypes, Banks) => {
        let locR = getLS("DataRem", {});
        const inveTypeIndex = getInveTypeIndex(valCust.Cust_inv_type);

        setIData({
            ...location.state.idata,
            branch: locR.branchi,
            sales_emp: locR.empi,
            create_user: locR.idi,
            customer_name: valCust.name,
            cust_id: valCust.id,
            inv_type: locStoTypes[inveTypeIndex].id,
            //eds change

            date: moment(new Date()).format("YYYY-MM-DD"),
        });
        // eds change
    };

    // const changAutoType = (newValue) => changRelationAutos("type", newValue);
    const changAutoType = (newValue) => {

        console.log(newValue);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });
        setValueType(newValue);

        let invT = newValue.id;
        if (newValue.id === 2) {
            if (switchState.cashORnetworksw === false) {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });

                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
            }
            else if (switchState.cashORnetworksw == true) {
                setUiElement({ ...uiElement, bank: false });
                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });

                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: true });
                setLbl({ ...lbl, chashNetwork: transForm("network") });
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setIData({
                    ...idata,
                    pay_type: 2,
                    bank: AutoOptions.Banks[0].id,
                    cust_id: valueCustomers.id, customer_name: valueCustomers.name,
                    inv_type: invT,
                });
            } else {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });

                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
            }
        }
        else if (newValue.id === 1) {
            if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {
                if (switchState.cashORnetworksw === false) {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: AutoOptions.Stocks[0].id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });
                }
                else if (switchState.cashORnetworksw === true) {
                    remains.cashPart = 0;
                    remains.agelPart = payment.stay;
                    remains.networkPart = payment.paidup;
                    remains.bankPart = 0;
                    setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: valueBank.id,
                        cash_part: 0,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: payment.paidup,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        inv_type: invT,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });

                } else {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: AutoOptions.Stocks[0].id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        cust_id: valueCustomers.id, customer_name: valueCustomers.name
                    });
                }

            } else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    Remaining: idata.netAmount,
                    Pay_mouny: 0,
                    agel_part: idata.netAmount,
                    inv_type: invT,
                });
            }
            else {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata, pay_type: -1, bank: -1, inv_type: invT
                    , agel_part: payment.stay, Remaining: payment.stay,
                    cash_part: payment.paidup
                });

            }
        }
        console.log(" the inv_type is", invT);
    };


    //const changAutoCustomers = (newValue) => changRelationAutos("cust", newValue);
    const changAutoCustomers = (newValue) => {

        console.log(newValue);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        let invT = null;
        setValueCustomers(newValue);
        newValue.Cust_inv_type == 1
            ? setValueType(AutoOptions.types[0])
            : setValueType(AutoOptions.types[1]);
        newValue.Cust_inv_type == 1
            ? (invT = AutoOptions.types[0].id)
            : (invT = AutoOptions.types[1].id);

        if (invT === 2) {

            if (newValue.Cust_inv_type != null) {
                if (newValue.Cust_inv_type == 0 || newValue.Cust_inv_type == 2 || newValue.Cust_inv_type == 5) {
                    setUiElement({
                        ...uiElement,
                        stock: false,
                        payMethod: false,
                        bank: true,
                    });
                    remains.cashPart = idata.netAmount;
                    remains.agelPart = 0;
                    remains.networkPart = 0;
                    remains.bankPart = 0;
                    setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                    setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });


                    const reet = reInshAuto(0, "");
                    setValueBank(reet);
                    setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });

                    setIData({
                        ...idata,
                        pay_type: 1,
                        bank: 0,
                        inv_type: invT,
                        customer_name: newValue.name,
                        cust_id: newValue.id,
                    });
                } else if (newValue.Cust_inv_type == 3 || newValue.Cust_inv_type == 4) {

                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                    setValueBankPMD(AutoOptions.Banks[0]); //getAutobanks(0);
                    setUiElement({ ...uiElement, bank: false });
                    setSwitchState({ ...switchState, cashORnetworksw: true });
                    setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });
                    setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                    setIData({
                        ...idata,
                        pay_type: 2,
                        bank: AutoOptions.Banks[0].id,
                        inv_type: invT,
                        customer_name: newValue.name,
                        cust_id: newValue.id,
                    });
                }
            }
            else {
                setUiElement({
                    ...uiElement,
                    stock: false,
                    payMethod: false,
                    bank: true,
                });

                setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
                setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

                const reet = reInshAuto(0, "");
                setValueBank(reet);
                setValueBankPMD(reet);
                setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });

                setIData({
                    ...idata,
                    pay_type: 1,
                    bank: 0,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                });
            }
        }
        else if (invT === 1) {

            if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {


                if (switchState.cashORnetworksw === false) {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: valueStock.id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                }
                else if (switchState.cashORnetworksw === true) {
                    remains.cashPart = 0;
                    remains.agelPart = payment.stay;
                    remains.networkPart = payment.paidup;
                    remains.bankPart = 0;
                    setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: valueBank.id,
                        cash_part: 0,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: payment.paidup,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                }
                else {
                    setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

                    setIData({
                        ...idata,
                        pay_type: -1,
                        bank: -1,
                        stock: valueStock.id,
                        cash_part: payment.paidup,
                        Pay_mouny: payment.paidup,
                        Remaining: payment.stay,
                        network_part: 0,
                        agel_part: payment.stay,
                        emp_part: 0,
                        bank_part: 0,
                        check_refno: "",
                        netAmountPMDcn: idata.netAmount,
                        customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
                    });
                }

            } else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    Remaining: idata.netAmount,
                    Pay_mouny: 0,
                    agel_part: idata.netAmount,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                });
            }
            else {
                setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
                setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

                setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
                const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
                setValueStock(reetS);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...idata,
                    pay_type: -1,
                    bank: -1,
                    inv_type: invT,
                    customer_name: newValue.name,
                    cust_id: newValue.id,
                    agel_part: payment.stay,
                    Remaining: payment.stay,
                    cash_part: payment.paidup
                });
            }
        } else {
            setIData({
                ...idata,
                customer_name: newValue.name,
                cust_id: newValue.id,
            });
        }

        // else if (invT == 1) {

        // }

        console.log(" the inv_type is", invT);
    };

    const changAutoSalesMen = (newValue) => {
        setValueSalesmen(newValue);
        toDoIdata("salesman", newValue.id);
    };

    const changAutoEmployee = (newValue) => {
        setValueEmployePMD(newValue);
        toDoIdata("emp", newValue.id);
    };



    const changAutoSafes = (newValue) => {
        setValueSafes(newValue);
        toDoIdata("safe", newValue.id);
    };
    const changAutoStock = (newValue) => {
        setValueStock(newValue);
        toDoIdata("stock", newValue.id);
    };

    const changAutoCostcenter = (newValue) => {
        setValueCostcenter(newValue);
        toDoIdata("center", newValue.id);
    };
    const changAutoBank = (newValue) => {
        setValueBank(newValue);
        toDoIdata("bank", newValue.id); /*setValueBankPMD(newValue);*/
    };
    const changAutoBankPMD = (newValue) => {
        setValueBankPMD(newValue);
        toDoIdata("bank2", newValue.id);
    };
    const valueAutoBankPaid = (newValue) => {
        setValueBanksPaid(newValue);
        setRemains({ ...remains, bankId: newValue.id });
        toDoIdata("bank2", newValue.id);
    };

    const changAutoBank2 = (newValue) => {
        setValueBankTransPMD(newValue);
        toDoIdata("bank2", newValue.id);
    };
    const changeOrderType = (newValue) => {
        setOrderData({ ...orderData, select: newValue });
        setIData({ ...idata, OrderTypeA: newValue.label, OrderTypeE: newValue.name });
    };
    const [cuRows, setcuRows] = useState({});

    const [searchedInvShow, setSearchedInvShow] = useState("");
    const [searchedCurrShow, setSearchedCurrShow] = useState("");

    // fillter groups

    const changFavSlides = (val) => {
        const res = gets.CurrenciesFav.filter((x) => x.favorite === val);
        setFavGroups(res);
    };

    const [checked, setChecked] = useState(insh.Checked);
    const RestAfterGetCurrMathRate = () => {
        setInvDisc(insh.InvDisc);
        afterGetCurrMathRate("");
    };

    const changChcked = (event) => {
        if (
            event.target.name === "discMinusck" ||
            event.target.name === "discRateck"
        ) {
            RestAfterGetCurrMathRate();

            if (event.target.name === "discMinusck") {
                setChecked({
                    ...checked,
                    discMinusck: event.target.checked,
                    discRateck: false,
                });
                setUiElement({ ...uiElement, rate: true, minus: false });
            } else if (event.target.name === "discRateck") {
                setChecked({
                    ...checked,
                    discMinusck: false,
                    discRateck: event.target.checked,
                });
                setUiElement({ ...uiElement, rate: false, minus: true });
            }
        }

        if (event.target.name === "networkck" || event.target.name === "cashck") {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setValueBankPMD(insh.AutoBank); //setOptionsBankPMD(insh.AutoBankOp);

            if (event.target.name === "networkck") {
                setChecked({ ...checked, networkck: true, cashck: false });
                setUiElement({ ...uiElement, bank: false });
                setValueBank(gets.Banks[0]); //getAutobanks(0);
                setValueBankPMD(gets.Banks[0]); //getAutobanksPMD(0);
            } else if (event.target.name === "cashck") {
                setChecked({ ...checked, networkck: false, cashck: true });
                setUiElement({ ...uiElement, bank: true });
                // setI_Data({...idata, pay_type:1 });
            }
        }

        /* ======== for payment Diloag ======== */
        if (event.target.name == "paymentDiloagck") {
            setChecked({ ...checked, paymentDiloagck: event.target.checked });
        } else if (event.target.name == "network_partck") {
            setChecked({
                ...checked,
                network_partck: event.target.checked,
                cash_partck: true,
            });
            if (event.target.checked === true) {
                setValueBankPMD(gets.Banks[0]);
        /*getAutobanksPMD(0);*/ changChckedPM("", "", "", "", "bankPM");
                chashVSnetwork(true);
                setUiElement({ ...uiElement, bankPM: false });
            } else if (event.target.checked === false) {
                MathChckedIdata("network_part", idata.network_part);
                changAutosPM("", "", "", "bankPM");
                chashVSnetwork(false);
                setUiElement({ ...uiElement, bankPM: true });
            }
        } else if (event.target.name === "agel_partck") {
            setChecked({
                ...checked,
                agel_partck: event.target.checked,
                cash_partck: true,
            });
            if (event.target.checked === false) {
                MathChckedIdata("agel_part", idata.agel_part);
            }
        } else if (event.target.name === "bank_partck") {
            setChecked({ ...checked, bank_partck: event.target.checked });
            if (event.target.checked === true) {
                setValueBankTransPMD(gets.Banks[0]);
        /*getAutobanks2PMD(0);*/ changChckedPM("", "", "", "", "bankPM2");
            } else if (event.target.checked === false) {
                MathChckedIdata("bank_part", idata.bank_part);
                changAutosPM("", "", "", "bankPM2");
            }
        } else if (event.target.name === "emp_partck") {
            setChecked({ ...checked, emp_partck: event.target.checked });
            if (event.target.checked === true) {
                setValueEmployePMD(gets.Employees[0]);
        /*getAutoEmployePMD(0);*/ changChckedPM("", "", "", "", "empPM");
            } else if (event.target.checked === false) {
                MathChckedIdata("emp_part", idata.emp_part);
                changAutosPM("", "", "", "empPM");
            }
        } else if (event.target.name === "autoOrStaticck") {
            setChecked({ ...checked, autoOrStaticck: event.target.checked });
        }
    }; // end checked
    const fltringAutoCurrUnits = (chitem) => {
        setIndexUnit(0);
        const res = [];
        setCurrUnitsAll(chitem);
        if (checked.autoOrStaticck == false) {
            setOptionsCurrUnits(chitem);
            setValueCurrUnits(chitem[0]);
            LetvalueCurrUnits = chitem[0];
        } else LetvalueCurrUnits = chitem[0];
    };
    const BefBarcodedataCurrencie = async (id, ious) => {
        setItemId(id);
        setCurrUnit(ious);
        // permiCuCo.DTSP = false;
        await fltringAutoCurrUnits(ious);
        insh.stateChang.taxperc = true;
        await fltringCurrencieToinv(
            ious[0],
            valuePricePay.id,
            insh.stateChang.taxperc
        );
        // eds change
        await changeCountCurr(ious[0].barcode);
    };

    const BefrowDataCurrencie = async (id, ious) => {
        setItemId(id);

        setCurrUnit(ious);
        // permiCuCo.DTSP = false;
        await fltringAutoCurrUnits(ious);
        insh.stateChang.taxperc = true;
        await fltringCurrencieToinv(
            ious[0],
            valuePricePay.id,
            insh.stateChang.taxperc
        );
        await changeCountCurr(ious[0].barcode);
    };

    const changeCountCurr = (bc) => {
        try {
            const resCurr = [];
            countCurrBySafe.map((x) => {
                if (x.barcode == bc && x.safe == valueSafes.id) resCurr.push(x);
            });
            if (checked.autoOrStaticck === false) {
                resCurr.length != 0
                    ? setCounts({ curr: resCurr[0].Qtys })
                    : setCounts({ curr: 0 });
            } else {
                resCurr.length != 0
                    ? (counts.curr = resCurr[0].Qtys)
                    : (counts.curr = 0);
            }
        } catch (error) {
            alert("هناك خطاء في الصنف قم برماجعة الدعم الفني");
        }
    };

    const retPrmiSDPandSDV = (val, prmPandV, f) => {
        if (val > prmPandV && f === "DiscP") {
            alert(`
قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
قيمة الخصم الممنوحه: ${prmPandV}
سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
      `);
            return "";
        } else if (val > prmPandV && f === "DiscC") {
            alert(`
قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
قيمة الخصم الممنوحه: ${prmPandV}
سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
      `);
            return "";
        }
    };


    const changInvs = (prop) => (event) => {
        setInfoInv({ ...infoInv, [prop]: event.target.value });
        setIData({ ...idata, InvId_Return: event.target.value });
    };

    const handClickInvs = async () => {
        if (infoInv.InvId_Return === "") {
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "أدخل رقم المرتجع",
                time: 2000,
            });
        } else {
            let isExsist = false,
                pipt = setting.PrTy_InPr == "12" ? "02" : "01",
                piptName = setting.PrTy_InPr == "12" ? "مبيعات" : "مشتريات";
            await axios
                .get(
                    uri +
                    `InvRet?invId_Return=${infoInv.InvId_Return}&&temp=${0}&&PcIdIvPc=${setting.PrTy_InPr
                    }`
                )
                .then((res) => {
                    console.log("res.data");
                    console.log(res.data);
                    for (let i = 0; i < res.data.length; i++) {
                        if (
                            parseInt(res.data[i].InvId_Return) ==
                            parseInt(infoInv.InvId_Return)
                        )
                            isExsist = true;
                    }
                })
                .catch((error) => { });

            // alert(isExsist)
            if (isExsist == true) {
                handOSnack({
                    vertical: "top",
                    horizontal: "right",
                    severit: "warning",
                    text: `فاتورة ${piptName} المدخلة تم إرجاعها مسبقا`,
                    time: 4000,
                });
            } else {
                await axios
                    .get(
                        uri +
                        `InvRet?id=${infoInv.InvId_Return}&&PcIdIvPc=${pipt}&&branch=${sto.branchi}`
                    )
                    .then((res) => {
                        showChosedInv(false, res.data.proc_id);

                        setOr({ ...or, postput: "toPost" });
                    })
                    .catch((error) => {
                        handOSnack({
                            vertical: "top",
                            horizontal: "right",
                            severit: "warning",
                            text: "رقم المرتجع غير موجود",
                            time: 2000,
                        });
                    });
            } // else c
        } // else m

        // eds changes
        if (!stor.hasOwnProperty("comt")) setStor({ ...stor, comt: -1 });
    };
    const beZero = () => {
        setStor({ ...stor, comt: -1 });
        if (subInfo.discount === "") subInfo.discount = 0;
        if (subInfo.DiscPers === "") subInfo.DiscPers = 0;
        if (subInfo.Price === "") subInfo.Price = 0;
        if (subInfo.val1 === "") subInfo.val1 = 0;
        if (subInfo.perc === "") subInfo.perc = 0;
        if (subInfo.taxperc === "") subInfo.taxperc = 0;
        if (subInfo.taxval === "") subInfo.taxval = 0;
        if (subInfo.totJust === "") subInfo.totJust = 0;
    };

    const getrowDataCurrencie = async () => {
        beZero();
        or.cros = "newRow";
        or.PrAC = 0;

        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") {
            if (subInfo.barcode != "") {
                if (parseFloat(subInfo.val1) != 0) {
                    let val1InSub = 0,
                        countsCurr = 0,
                        subInfoVal1_perc = subInfo.val1 * subInfo.perc;

                    for (let m = 0; m < isdata.length; m++) {
                        if (subInfo.barcode == isdata[m].barcode)
                            val1InSub = isdata[m].val1;
                    }
                    countsCurr = parseInt(counts.curr) - parseInt(val1InSub);

                    if (
                        setting.PrTy_InPr == "12" ||
                        permistionInv.SIM == true ||
                        countsCurr >= subInfoVal1_perc ||
                        subInfo?.type == 4
                    ) {
                        /* الكمية مؤقت */
                        if (permistionInv.ASPZ === 1 || subInfo.Price > 0) {
                            /* قيمة صفرية */

                            if (
                                permistionInv.USP === true ||
                                indexUnit !== 0 ||
                                parseFloat(subInfo.Price) >= parseFloat(subInfo.minPrice)
                            ) {
                                /* سعر البيع اقل من الـسعر الادنى */

                                for (let m = 0; m < isdata.length; m++) {
                                    //  alert(parseInt(subInfo.Price)+' == '+parseInt(isdata[m].new_exchange_price) +' && '+ subInfo.barcode+' == '+isdata[m].barcode)
                                    if (
                                        parseInt(subInfo.Price) ==
                                        parseInt(isdata[m].new_exchange_price) &&
                                        subInfo.barcode == isdata[m].barcode
                                    ) {
                                        or.cros = "rnewRow";
                                        or.i = m;
                                        break;
                                    } else {
                                        or.cros = "newRow";
                                    }
                                }

                                await handRowAdd(or);
                                // await reCountCurr();
                                await handleCloseCuDWithSWState();
                                await handleClDia("fav", false);
                                await setSubInfo(insh.InfoSub);
                                setCurrUnit([]);
                                //} /* end ISPLP */ // else{alert('سعر البيع اقل من سعر الشراء')}
                            } /* end USP */ else
                                alert(
                                    `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو : ${subInfo.minPrice}`
                                );
                        } /* price > 0 */ else alert("السعر اقل من صفر");
                    } /* end val1 Curr */ else {
                        alert(
                            `
          الكمية المدخلة للصنف أكبر من رصيد المخزن
          الكمية الاجمالية المدخلة : ${parseFloat(subInfo.val1) * parseFloat(subInfo.perc)
                            }
          رصيد المخزن : ${valueSafes.name} = ${parseInt(counts.curr) - parseInt(val1InSub)
                            }
          `
                        );
                    }
                } /* end Val1 */ else {
                    alert("لا يمكنك التنزيل الكمية 0");
                }
            } /* end barcode */ else {
                alert("لا يوجد باركود للصنف تحقق من البيانات");
            }
        } else {
            if (subInfo.barcode !== "") {
                if (parseFloat(subInfo.val1) !== 0) {
                    let val1InSub = 0;
                    for (let m = 0; m < isdata.length; m++) {
                        if (subInfo.barcode == isdata[m].barcode)
                            val1InSub = isdata[m].val1;
                    }

                    if (permistionInv.ASPZ === 1 || subInfo.Price > 0) {
                        for (let m = 0; m < isdata.length; m++) {
                            if (
                                parseInt(subInfo.Price) ==
                                parseInt(isdata[m].new_exchange_price) &&
                                subInfo.barcode == isdata[m].barcode
                            ) {
                                or.cros = "rnewRow";
                                or.i = m;
                                break;
                            } else {
                                or.cros = "newRow";
                            }
                        }

                        await handRowAdd(or);
                        await handleCloseCuDWithSWState();
                        await setSubInfo(insh.InfoSub);
                        setCurrUnit([]);
                    } /* price > 0 */ else alert("السعر اقل من صفر");
                } /* end Val1 */ else {
                    alert("لا يمكنك التنزيل الكمية 0");
                }
            } /* end barcode */ else {
                alert("لا يوجد باركود للصنف تحقق من البيانات");
            }
        }
    };

    // const noGetThings = () => { return null;}

    const inputRef = useRef(null);
    const keepFocus = () => {
        let AutoItem = permistionInv?.AUTI == null ? true : permistionInv?.AUTI;
        if (AutoItem && inputRef?.current) {
            inputRef?.current.focus();
        }
    };

    const handNewInv = () => {
        // alert('hand New Inv');
        setOpenPrint({ ...openPrint, open: false, localInv: {}, });
        setIsLoading(false);
        setIshedden(false);
        setIsOpenUpdate(false);
        reLoadLastInv();
        setIsData([]);
        if (!permistionInv.SIM) { setLocalCashe([]); }
        // setLocalCasheItems([]);
        setOrderData({ ...orderData, select: selectOrderType[0] });
        setValueCustomers(AutoOptions.Customers[0]); //getAutoCustomers(0);
        setValueSalesmen(insh.Auto);
        setValueCostcenter(insh.Auto);
        // condshSet_ValueType
        // const inveTypeIndex = getInveTypeIndex(optionsCustomers[0].Cust_inv_type);

        // changAutoType(gets.types[inveTypeIndex], false); //chang_AutoType(optionsType[1]);
        setOmlaValue(getDefaultOmla(gets.omlats));
        // const safe = getSafeDefault(gets.permisApp.user_id, gets.Users);
        let defStock = AutoOptions.Stocks[0];
        let typePayCust = Number(AutoOptions.Customers[0]?.Cust_inv_type);
        setValueStock(defStock); //setOptionsBank(insh.AutoBankOp);

        if (typePayCust != null) {
            if (typePayCust == 0 || typePayCust == 2) {
                setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
                setUiElement({ ...uiElement, bank: true });
                setSwitchState({ ...switchState, cashORnetworksw: false });
                setLbl({ ...lbl, chashNetwork: transForm("cash") });
                setUiElement({ ...uiElement, bank: true });
                setIData({
                    ...location.state.idata,
                    inv_type: 2, pay_type: 1, bank: 0, cust_id: optionsCustomers[0].id,
                    customer_name: AutoOptions.Customers[0].name, date: moment(new Date()).format("YYYY-MM-DD"),
                    trans_no: AutoOptions.maxShift.id, stock: defStock.id
                });
                // setValueStock(defStock); //setOptionsBank(insh.AutoBankOp);
                setValueType(AutoOptions.types[1]);
            } else if (typePayCust == 1) {
                // setValueStock(defStock); //setOptionsBank(insh.AutoBankOp);
                const reetB = reInshAuto(-1, "");
                setValueBank(reetB);
                setIData({
                    ...location.state.idata, inv_type: 1, pay_type: -1, bank: -1, cust_id: AutoOptions.Customers[0].id,
                    customer_name: AutoOptions.Customers[0].name, date: moment(new Date()).format("YYYY-MM-DD"),
                    trans_no: AutoOptions.maxShift.id, stock: defStock.id
                });
                setValueType(AutoOptions.types[0]);
            } else if (typePayCust == 3 || typePayCust == 4) {
                const text = transForm("network").toString();
                setLbl({ ...lbl, chashNetwork: text });
                setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
                setValueBankPMD(AutoOptions.Banks[0]); //getAutobanks(0);
                setUiElement({ ...uiElement, bank: false });
                setSwitchState({ ...switchState, cashORnetworksw: true });
                setValueType(AutoOptions.types[1]); //getAutobanks(0);
                setIData({
                    ...location.state.idata, inv_type: 2, pay_type: 2, bank: AutoOptions.Banks[0].id, cust_id: AutoOptions.Customers[0].id,
                    customer_name: optionsCustomers[0].name, date: moment(new Date()).format("YYYY-MM-DD"),
                    trans_no: AutoOptions.maxShift.id, stock: defStock.id,
                });
            }
        } else {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setValueBankPMD(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true });
            setSwitchState({ ...switchState, cashORnetworksw: false });
            setIData({
                ...location.state.idata, inv_type: 2, pay_type: 1, bank: 0, cust_id: AutoOptions.Customers[0].id, stock: defStock.id,
                customer_name: AutoOptions.Customers[0].name, date: moment(new Date()).format("YYYY-MM-DD"),
                trans_no: AutoOptions.maxShift.id,
            });
            setValueType(AutoOptions.types[1]);
        }
        setValueSafes(AutoOptions.Safes[0]);
        setSums(insh.Sums);
        setStor({ ...stor, comt: -1 });
        setExSub(0);
        setPayment(insh.Payment);
        setRemains(insh.Remains);
        setChecked({
            ...checked,
            costWithVat: true,
            discMinusck: false,
            discRateck: false,
            networkck: false,
            cashck: true,
            network_partck: false,
            cash_partck: false,
            agel_partck: false,
            bank_partck: false,
            emp_partck: false,
            // autoOrStaticck:false,
        });
        setOr(insh.Or);
        setInvDisc(insh.InvDisc);
        setRowUpdate({});
        // keepFocus();
    };

    // editable?: ('always' | 'onUpdate' | 'onAdd' | 'never');
    // func m t

    // func m t
    const befPushTos = async () => {
        addChangds();
    };

    let his = useHistory();
    const [generating, setGenerating] = useState(false);

    const toPrint = async (type, e, hist) => {
        or.PrAC = hist;
        if (isdata.length > 0) await toWhere(type, e);
        else
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "يجب تنزيل اصناف",
                time: 2000,
            });
    };
    const toPrintCashOrNetwork = (type, e, hist, valChecked) => {
        let isSave = 0;
        if (valChecked == true && valueType.id !== 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

            setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id });
            isSave = 1;

            setValueType(AutoOptions.types[1]);

            remains.networkPart = idata.netAmount;
            remains.agelPart = 0;
            remains.bankPart = 0;
            remains.cashPart = 0;
            idata.bank = AutoOptions.Banks[0].id
            idata.pay_type = 2;
            idata.inv_type = 2;
            idata.cash_part = 0;
            idata.agel_part = 0;
            idata.bank_part = 0;
            idata.network_part = idata.netAmount;

            setChecked({
                ...checked,
                cash_partck: false,
                network_partck: true,
                agel_partck: false,
            });
            isSave = 1;

        } else if (valChecked == false && valueType.id !== 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true, stock: false });
            setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

            setValueType(AutoOptions.types[1]);
            remains.cashPart = idata.netAmount;
            remains.agelPart = 0;
            remains.bankPart = 0;
            remains.networkPart = 0;
            idata.pay_type = 1;
            idata.inv_type = 2;
            idata.cash_part = idata.netAmount;
            idata.agel_part = 0;
            idata.bank_part = 0;
            idata.network_part = 0;

            setChecked({
                ...checked,
                cash_partck: true,
                network_partck: false,
                agel_partck: false,
            });
            isSave = 1;


        } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
            setUiElement({ ...uiElement, bank: false });
            setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
            setValueType(AutoOptions.types[0]);
            remains.networkPart = payment.paidup;
            remains.agelPart = payment.stay;
            remains.bankPart = 0;
            remains.cashPart = 0;
            idata.bank = AutoOptions.Banks[0].id
            idata.pay_type = -1;
            idata.inv_type = 1;
            idata.cash_part = payment.stay;
            idata.agel_part = 0;
            idata.bank_part = 0;
            idata.network_part = payment.paidup;

            setChecked({
                ...checked,
                cash_partck: false,
                network_partck: true,
                agel_partck: false,
            });
            isSave = 1;

        }
        else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
            setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({ ...uiElement, bank: true });
            setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
            setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
            isSave = 1;


            setValueType(AutoOptions.types[0]);
            remains.cashPart = payment.paidup;
            remains.agelPart = payment.stay;
            remains.bankPart = 0;
            remains.networkPart = 0;
            idata.pay_type = -1;
            idata.inv_type = 1;
            idata.cash_part = payment.paidup;
            idata.agel_part = payment.stay;
            idata.bank_part = 0;
            idata.network_part = 0;

            setChecked({
                ...checked,
                cash_partck: true,
                network_partck: false,
                agel_partck: false,
            });
            isSave = 1;
        }
        if (isSave == 1) { toPrint(type, e, hist); }

    };


    const handPrint = async (procid, invs) => {
        const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
        const localInvoive = {
            proc_id: procid,
            invN: setting.titleHed,
            invNEn: setting.titleHedEn,
            salesman: valueSalesmen.name,
            backInv: "InvSO",
            branch: props.isDialog == false ? sto.branchi : props.invData.branch,
            ProcTypeInvProc: setting.PrTy_InPr,
            Delivery: permistionInv?.PRNTOUT,
            Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
            Direct: i18next.language == "ar" ? true : false,
            NRound: permistionInv?.ROUND == null ? 4 : permistionInv?.ROUND,
            UseBefore: permistionInv?.USEBEFORE == null ? 1 : permistionInv?.USEBEFORE,
            branchInv: props.isDialog == false ? sto.branchi : props.invData.branch,
            salesmanName: "",
            invs: invs,
            post: 0,
            title: setting.titleHed + " " + "رقم:" + invs?.id + " خاصة ب: " + invs?.customer_name
        }
        if (or.PrAC === 2 || or.PrAC === 1) {
            let invType = 1;
            if (or.PrAC === 2) {
                const num = Number(premiApp.billTemplate);
                if ([4, 8, 18, 23, 28, 29].includes(num)) {
                    invType = 4;
                } else if ([5, 9, 21, 22, 24, 25, 26, 27, 30].includes(num)) {
                    invType = 2;
                } else if ([6, 16, 19].includes(num)) {
                    invType = 3;
                } else if ([7, 2].includes(num)) {
                    invType = 5;
                } else if (num === 10) {
                    invType = 6;
                } else {
                    invType = 1;
                }
                setOpenPrint({ open: true, localInv: localInvoive, invType: invType, invKind: 2 });
            } else {
                const num = Number(premiApp.cashirTemplate);
                if ([2, 6].includes(num)) {
                    invType = 3;
                } else if ([4, 5, 7].includes(num)) {
                    invType = 2;
                } else { invType = 1; }
                setOpenPrint({ open: true, localInv: localInvoive, invType: invType, invKind: 1 });
            }
        } else {
            handleDirectPrintRest(
                localInvoive,
                handNewInv,
                AutoOptions?.permType?.id === 7 ? permistionInv?.NOCOPY : 1,
                premiApp,
                foundData,
                setFoundData,
            );
            isSavingRef.current = false;
            setIsLoading(false);
        }
    };

    const PushTos = async (t) => {
        setIsLoading(true);
        befPushTos();
        let Sa_or_Pa_rest_id = null;
        console.log("the data is", remains);
        await ButtonLoading(t);

        const model = {
            inv: {
                ...idata,
                Pay_mouny: payment.paidup ? payment.paidup : 0,
                Remaining: payment.stay,
                agel_part: remains.agelPart,
                cash_part: remains.cashPart,
                network_part: remains.networkPart,
                bank_part: remains.bankPart,
                emp_part: remains.empPart,
                trans_no: maxShifts,
                center: valueCostcenter.id ?? -1,
                cust_id: valueCustomers.id,
                customer_name: valueCustomers.name,
                OrderNo: maxOrderNo,
                OrderNoType: orderData?.select?.id,
                OrderTypeA: orderData?.select?.label,
                OrderTypeE: orderData?.select?.name,
                vat_type: or.postput === "toPut" ? idata.vat_type : permiCuCo.CWVat ? 1 : 0,
                //cust_id:valueCustomers.id,
                //  cust_id:valueCustomers.id,

            },
            // stor: stor,

            stor: {
                ...stor,
                Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
                isOrder: false,
                orderId: 0
            },


            parms: {
                omlaId: omlaValue?.id,
                tobaccoFees: premiA.tobaccoFees,
                omlaExchange: omlaValue?.exchange,
                iuserid: idata.create_user,
                iformidCuCo: dataF[3].id,
                proc_type: setting.routIS == "Inv_Sub_ToS/" ? 2 : 1,
                yashml: permiCuCo.yashml == "W",
                isAgel: remains?.isAgel,
                isCash: remains?.isCash,
                isNetwork: remains?.isNetwork,
                isBank: remains?.isBank,
                isEmp: remains?.isEmp,
                isWindow: remains?.isWindow,
                empId: remains?.empId,
                bankId: valueBanksPaid?.id,
                bankAcc: valueBanksPaid?.i,
                networkId: valueBankPMD?.id,
                networkAcc: valueBankPMD?.i,
                stockAcc: valueStock?.acc ?? 0,
                acc_no: valueCustomers?.acc_no,
            },
            State: "Post",
            _Data: isdata,
        };

        if (or.postput == "toPost") {
            await axios
                .post(uri + "_HInv", model)
                .then((resI) => {
                    /*console.log('done I_po');*/
                    console.log(" the  data is", model);

                    if (or.PrAC !== 0) handPrint(resI.data.proc_id, resI.data);
                    ButtonSuccess(t, true);
                })
                .catch((resI) => {
                    handOSnack({
                        vertical: "top",
                        horizontal: "right",
                        severit: "warning",
                        text:
                            "لم يتم اضافة الفاتورة" + "بسبب " + resI.response?.data?.Message,
                        time: 2000,
                    });

                    ButtonSuccess(t, false);
                });
        } else if (or.postput == "toPut") {
            await ButtonLoading(t);
            // I_Pu
            console.log(" the  data is", model);
            if (permistionInv.Up && isOpenUpdate) {

                await axios
                    .put(uri + "_HInv", model)
                    .then((resI) => {
                        /*console.log('done I_po');*/
                        console.log(" the  data is", model);

                        if (or.PrAC !== 0) handPrint(resI.data.proc_id, resI.data);
                        ButtonSuccess(t, true);
                    })
                    .catch((resI) => {
                        handOSnack({
                            vertical: "top",
                            horizontal: "center",
                            severit: "warning",
                            text:
                                "لم يتم تعديل الفاتورة" +
                                "  " +
                                "بسبب " +
                                resI.response?.data?.Message,
                            time: 2000,
                        });
                        ButtonSuccess(t, false);
                    });
            } else {
                const tb = { inv: idata, stor: stor };
                await axios
                    .put(uri + "Inv_R_RS_", tb)
                    .then((resI_Pu) => {
                        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                            Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
                        else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;
                        if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id, resI_Pu.data);
                        ButtonSuccess(t, true);
                    })
                    .catch((resI_Pu) => {
                        ButtonSuccess(t, false); /*console.log('no I_Pu');*/
                    });
            }
        }
    };

    const PushTost = async (t) => {
        befPushTos();
        let Sa_or_Pa_rest_id = null;
        if (or.postput == "toPost") {
            await ButtonLoading(t);
            const tb = {
                invtemp: idata,
                stor: stor,
                parms: {
                    iuserid: idata.create_user,
                    iformidCuCo: dataF[3].id,
                },
            };

            await axios
                .post(uri + "Inv_R_RS__", tb)
                .then((resI) => {
                    /*console.log('done I_po');*/
                    axios
                        .post(
                            uri +
                            setting.routIS +
                            permiCuCo.yashml +
                            "?pcid=" +
                            resI.data.proc_id +
                            "&&State=Postt",
                            isdata
                        )
                        .then((resS) => {
                            /*console.log('done IS_po');*/
                            if (or.PrAC !== 0) handPrint(resI.data.proc_id);
                            ButtonSuccess(t, true);
                        })
                        .catch((resS) => {
                            /*console.log('no IS_po');*/
                        });
                })
                .catch((resI) => {
                    ButtonSuccess(t, false);
                });
        }
        if (or.postput == "toPut") {
            await ButtonLoading("t");
            // I_Pu
            const tb = { inv: idata, stor: stor };

            await axios
                .put(uri + "Inv_R_RS", tb)
                .then((resI_Pu) => {
                    /*console.log('done I_Pu');*/

                    if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                        Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
                    else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;

                    // R_Pu
                    axios
                        .put(uri + "Restrictions" + "?pcid=" + resI_Pu.data.proc_id)
                        .then((retR_Pu) => {
                            /*console.log('done R_Pu');*/
                        })
                        .catch((retR_Pu) => {
                            /*console.log('no R_Pu');*/
                        });

                    // IS_De&Po
                    axios
                        .post(
                            uri +
                            setting.routIS +
                            permiCuCo.yashml +
                            "?pcid=" +
                            resI_Pu.data.proc_id +
                            "&&State=rePost",
                            isdata
                        )
                        .then((resIS_Po) => {
                            /*console.log('done resIS_Po');*/
                        })
                        .catch((resIS_Po) => {
                            /*console.log('no resIS_Po');*/
                        });

                    // RS_De&Po
                    axios
                        .post(uri + "Restrictions_Sub" + "?idR=" + Sa_or_Pa_rest_id, idata)
                        .then((resRS_Po) => {
                            /*console.log('done RS_Po');*/
                        })
                        .catch((resRS_Po) => {
                            /*console.log('no RS_Po');*/
                        });

                    /* E inner */
                    if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id);
                    ButtonSuccess("t", true);
                })
                .catch((resI_Pu) => {
                    ButtonSuccess(t, false); /*console.log('no I_Pu');*/
                });
        }
    };
    const deleteTos = async (e) => {
        await e.preventDefault();
        ButtonLoading("delete");
        await axios
            .delete(uri + setting.routI_R_RS + "?pcid=" + parseInt(idata.proc_id))
            .then((resIsRs) => {
                ButtonSuccess("delete", true);
            })
            .catch((resIsRs) => {
                ButtonSuccess("delete", false);
            });
    };

    const loadePayMents = () => {
        //  alert(idata.netAmount)
        setPayment({
            ...payment,
            paidupPMDcn: payment.paidup,
            stayPMDcn: payment.stay,
        });

        if (switchState.cashORnetworksw == false && valueType.id == 2) {
            setChecked({
                ...checked,
                cash_partck: true,
                network_partck: false,
                agel_partck: false,
            });
            setIData({
                ...idata,
                cash_part: idata.netAmount,
                network_part: "",
                agel_part: "",
                emp_part: "",
                bank_part: "",
                check_refno: "",
                netAmountPMDcn: idata.netAmount,
            });
        } else if (switchState.cashORnetworksw == true && valueType.id == 2) {
            setChecked({
                ...checked,
                cash_partck: false,
                network_partck: true,
                agel_partck: false,
            });
            setIData({
                ...idata,
                cash_part: "",
                network_part: idata.netAmount,
                agel_part: "",
                emp_part: "",
                bank_part: "",
                check_refno: "",
                netAmountPMDcn: idata.netAmount,
            });

            setValueBankPMD(valueBank); //setOptionsBankPMD(optionsBank);
        } else if (valueType.id === 1) {
            setChecked({
                ...checked,
                network_partck: false,
                cash_partck: false,
                agel_partck: true,
            });
            setIData({
                ...idata,
                cash_part: "",
                network_part: "",
                agel_part: idata.netAmount,
                emp_part: "",
                bank_part: "",
                check_refno: "",
                netAmountPMDcn: idata.netAmount,
            });
        }
    };

    const usedPayedWindow = (v) => {
        if (v === 0) idata.used_payed_window = v;
        else idata.used_payed_window = v;
    };

    // ============================================ btn load
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const timer = React.useRef();

    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameSavetmp = clsx({
        [clasCAB.buttonSuccessCAB]: success.savetmp,
    });

    const buttonClassnameSavePMD = clsx({
        [clasCAB.buttonSuccessCAB]: success.savePMD,
    });

    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const buttonClassnamePrint = clsx({
        [clasCAB.buttonSuccessCAB]: success.print,
    });
    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    const ButtonLoading = (prop) => {
        setLoading({ ...loading, [prop]: true });
    };
    const ButtonSuccess = async (prop, state) => {
        buttonsFinsh(prop);
        if (
            prop == "delete" ||
            prop == "save" ||
            prop == "savetmp" ||
            prop == "savePMD"
        ) {
            try { await keepFocus(); } catch { }
            // if (or.PrAC!==3) {
            //     await handNewInv();
            // }
            await handNewInv();
        }
        if (prop == "savePMD") {
            await handClosePMD("done");
        }
        await ButtonLastFinsh(prop);
    };
    const buttonsFinsh = (prop) => {
        setLoading({ ...loading, [prop]: false });
        setSuccess({ ...success, [prop]: false });
    };
    const ButtonLastFinsh = (prop) => {
        setSuccess({ ...success, [prop]: false });
        if (or.PrAC != 3) {
            isSavingRef.current = false;
            setIsLoading(false);
        }
        // isSavingRef.current = false;
        // setIsLoading(false);
    };
    // ========================================== btn load
    const toDB = async (type, e) => {
        if (showPaid === true && type !== "savetmp" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04") {
            if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
                if (parseFloat(idata.netAmount) !== parseFloat(remains.allpart)) {
                    alert("المبلغ غير متساوي");
                } else if (isdata.length == 0) {
                    alert(" لا يوجد اصناف في الجدول ");
                } else if (parseFloat(idata.netAmount) == 0) {
                    alert(" لا يمكن حفظ الفاتورة باجمالي صفر    ");
                }
                else {
                    handClosePMD("cancle");
                    setIsLoading(true);
                    if (isSavingRef.current) return;
                    isSavingRef.current = true;
                    await PushTos(type);
                }
            } else {

                usedPayedWindow(0);

                if (type == "savetmp") {
                    await PushTost(type);
                } else {
                    if (isSavingRef.current) return;
                    isSavingRef.current = true;
                    setIsLoading(true);
                    await PushTos(type);
                }
            }
        } else {
            usedPayedWindow(0);
            if (type == "savetmp") {
                await PushTost(type);
            } else {
                setIsLoading(true);
                if (isSavingRef.current) return;
                isSavingRef.current = true;
                await PushTos(type);
            }
        }
    };

    const toDB2 = async (type, e) => {

        if (checked.paymentDiloagck === true) {
            if (parseFloat(idata.netAmountPMDcn) !== parseFloat(idata.netAmount)) {
                alert("المبلغ غير متساوي");
            } else {
                usedPayedWindow(1);
                await PushTos("savePMD");
            }
        } else {
            usedPayedWindow(0);

            if (type == "savetmp") {
                await PushTost(type);
            } else {
                await PushTos(type);
            }
        }
    };

    const paidFun = (type) => {


        if (valueType.id == 2) {
            setRemains({
                ...remains,
                cashPart: switchState.cashORnetworksw == false ? idata.netAmount : 0,
                agelPart: 0,
                bankPart: 0,
                networkPart: switchState.cashORnetworksw == true ? idata.netAmount : 0,
                empPart: 0,
                isCash: switchState.cashORnetworksw == false,
                isWindow: true,
                isNetwork: switchState.cashORnetworksw == true,
                isAgel: false,
                isEmp: false,
                allpart: idata.netAmount,
                typePress: type,
            });
            // setValueBank(gets.Banks[0]); //getAutobanks(0);

        } else if (valueType.id == 1 && parseFloat(payment.paidup) > 0) {
            setRemains({
                ...remains,
                cashPart: switchState.cashORnetworksw == false ? payment.paidup : 0,
                agelPart: payment.stay,
                bankPart: 0,
                networkPart: switchState.cashORnetworksw == true ? payment.paidup : 0,
                empPart: 0,
                isCash: switchState.cashORnetworksw == false,
                isWindow: true,
                isAgel: true,
                isEmp: false,
                isNetwork: switchState.cashORnetworksw == true,
                allpart: idata.netAmount,
                typePress: type,
            });

        } else {
            setRemains({
                ...remains,
                cashPart: 0,
                agelPart: idata.netAmount,
                bankPart: 0,
                networkPart: 0,
                empPart: 0,
                isCash: false,
                isWindow: true,
                isAgel: true,
                isEmp: false,
                isNetwork: false,
                allpart: idata.netAmount,
                typePress: type,
            });
        }

        setValueBankPMD(switchState.cashORnetworksw ? valueBank : AutoOptions.Banks[0]);
        setValueEmployePMD(gets.Employees[0]);
        setPayment({ ...payment, paidupPMDcn: payment.paidup, stayPMDcn: payment?.stay });
    }
    const handleClickOpenPaid = (type) => {
        typePress = type;
        setOpenPMD(true);
    };



    const sendToZatca = async (t) => {

        console.log("the data is", idata);
        const model = {
            ...idata,
            Pay_mouny: payment.paidup ? payment.paidup : 0,
            Remaining: payment.stay,
            agel_part: remains.agelPart,
            cash_part: remains.cashPart,
            network_part: remains.networkPart,
            bank_part: remains.bankPart,
            emp_part: remains.empPart,
        };
        if (or.postput == "toPut") {
            await ButtonLoading(t);
            // I_Pu
            console.log(" the  data is", model);

            const URL = uri + "Zatca/SignInvAndSendToZatca";
            await axios
                .post(URL, model)
                .then((resI) => {
                    ButtonSuccess(t, true);
                })
                .catch((resI) => {
                    handOSnack({
                        vertical: "top",
                        horizontal: "right",
                        severit: "warning",
                        text:
                            "لم يتم submite الفاتورة" +
                            "  " +
                            "بسبب " +
                            resI.response?.data?.Message,
                        time: 2000,
                    });
                    ButtonSuccess(t, false);
                });
        }
    };
    const toWhere = (type, e) => {
        if (type === "save" || type === "savetmp") or.PrAC = 0;
        if (valueCustomers.id === null || valueCustomers.id === "") {
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "تاكد من اختيار العميل",
                time: 2000,
            });
        } else if (permistionInv?.FORCECOST === true && valueCostcenter?.id < 1) {
            alert("you have to choose cost center");
        }
        else {
            if (isdata.length === 0) {
                // alert(" لا يوجد اصناف في الجدول ");
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "لا يوجد اصناف في الجدول ... برجاء تنزيل الاصناف",
                    time: 2000,
                });
            } else {
                if (AutoOptions?.StepTwo?.id == 1) {
                    const tb = {
                        CustStepTwo: true,
                        parms: {
                            cust_id: valueCustomers?.id,
                        },
                    };
                    axios
                        .post(uri + "GetD", tb)
                        .then((res) => {
                            if (res.data?.StepTwoNotes?.notes === "Good") {
                                toWhereSave(type, e);
                            } else {
                                handOSnack({
                                    vertical: "top",
                                    horizontal: "center",
                                    severit: "warning",
                                    text: res.data?.StepTwoNotes?.notes,
                                    time: 2000,
                                });
                            }
                        })
                        .catch((error) => {
                            toWhereSave(type, e);
                        });
                } else {
                    toWhereSave(type, e);
                }
            }

        }



    };


    const toWhereSave = (type, e) => {
        if (parseFloat(payment.paidup) > parseFloat(idata.netAmount)) {

            if (switchState.cashORnetworksw == true) {
                setValueType(AutoOptions.types[1]);

                remains.networkPart = idata.netAmount;
                remains.agelPart = 0;
                remains.bankPart = 0;
                remains.cashPart = 0;
                remains.empPart = 0;
                payment.paidup = idata.netAmount;
                payment.stay = 0;

                idata.pay_type = 2;
                idata.inv_type = 2;
                idata.cash_part = 0;
                idata.agel_part = 0;
                idata.bank_part = 0;
                idata.network_part = idata.netAmount;

                setChecked({
                    ...checked,
                    cash_partck: false,
                    network_partck: true,
                    agel_partck: false,
                });
                if (isdata.length > 0) {
                    if (showPaid === true) {
                        // loadePayMents();
                        ///handleClickOpenPMD(TransitionRight);
                        // loadePayMents();
                        paidFun(type);
                        handleClickOpenPaid(type);

                    } else

                        toDB(type, e);
                }
                else {
                    // handOSnack({ vertical: 'top', horizontal: 'center' });
                    handOSnack({
                        vertical: "top",
                        horizontal: "right",
                        severit: "warning",
                        text: transForm("most_download_item"),
                        time: 2000,
                    });
                }


            }
            else {
                setValueType(AutoOptions.types[1]);
                remains.cashPart = idata.netAmount;
                remains.agelPart = 0;
                remains.bankPart = 0;
                remains.networkPart = 0;


                payment.paidup = idata.netAmount;
                payment.stay = 0;
                idata.pay_type = 1;
                idata.inv_type = 2;
                idata.cash_part = idata.netAmount;
                idata.agel_part = 0;
                idata.bank_part = 0;
                idata.network_part = 0;

                setChecked({
                    ...checked,
                    cash_partck: true,
                    network_partck: false,
                    agel_partck: false,
                });
                if (isdata.length > 0) {
                    if (checked.paymentDiloagck === true) {
                        loadePayMents();
                        handleClickOpenPMD(TransitionRight);
                    } else

                        toDB(type, e);
                }
                else {
                    // handOSnack({ vertical: 'top', horizontal: 'center' });
                    handOSnack({
                        vertical: "top",
                        horizontal: "right",
                        severit: "warning",
                        text: transForm("most_download_item"),
                        time: 2000,
                    });
                }


            }
        }
        else {
            if (isdata.length > 0 && parseFloat(idata.netAmount) > 0) {
                if (showPaid === true && type !== "savetmp" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04") {
                    if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
                        paidFun(type);
                        handleClickOpenPaid(type);
                    } else {
                        toDB(type, e);
                    }
                } else { toDB(type, e); }
            } else if (isdata.length === 0) {
                // alert(" لا يوجد اصناف في الجدول ");
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: transForm("no_item_in_table"),
                    time: 2000,
                });
            } else if (parseFloat(idata.netAmount) === 0) {
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: transForm("cant_save_zero_invoice"),
                    time: 2000,
                });
            }
            else {
                // handOSnack({ vertical: 'top', horizontal: 'center' });
                handOSnack({
                    vertical: "top",
                    horizontal: "right",
                    severit: "warning",
                    text: transForm("most_download_item"),
                    time: 2000,
                });
            }
        }
    };
    const blurPaid2 = (pay) => {
        //event.preventDefault();
        if (pay > idata.netAmount) {
            let valueVcher = (pay - parseFloat(idata.netAmount)).toFixed(2);
            //event.stopPropagation();
            setVoucherDialog({
                isOpen: true,
                data: {
                    ...idata, id: infoInv.id,
                    omlaId: omlaValue.id,
                    exchange: omlaValue.exchange,
                    valueOfVoucher: valueVcher
                },
                onSuccess: () => {
                    // toDiloa
                    setVoucherDialog({ ...voucherDialog, isOpen: false });
                    toDoIdata("notes", "Receipt voucher for the amount:" + valueVcher);
                },

            });
            payment.paidupPMDcn = parseFloat(idata.netAmount);
            payment.stayPMDcn = payment.stay;
            payment.paidup = idata.netAmount;
            payment.stay = 0;
            //setPayment({ ...payment, paidup: parseFloat(idata.netAmount), stay: 0 });
        }
    };

    const hRowrAdd = (newData, resolve) => {
        let restaxvalrA = 0,
            resDiscPerA = 0,
            restotJustSumrA = 0,
            restotJustAfterDiscSumrA = 0,
            resDisCountrA = 0,
            resVal1SumrA = 0,
            resNetrA = 0,
            tot_before_vat_with_tab3val = 0,
            tot_before_only = 0,
            tot_before_new = 0,
            tot_befor_vat_after_disc = 0;

        resVal1SumrA = parseFloat(subInfo.val1) + parseFloat(isdata[or.i].val1);
        restotJustSumrA =
            parseFloat(isdata[or.i].new_exchange_price) * resVal1SumrA;

        resDisCountrA = (
            restotJustSumrA * parseFloat(subInfo.DiscPers / 100)
        ).toFixed(2);
        restotJustAfterDiscSumrA =
            parseFloat(restotJustSumrA) - parseFloat(resDisCountrA);


        tot_before_only =
            parseFloat(subInfo.totJust) - parseFloat(subInfo.discount);
        tot_before_new = maths(
            parseFloat(tot_before_only),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );

        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumrA),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );

        if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * resVal1SumrA) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

            let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalrA = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(subInfo.taxperc),
                "taxval"
            );

            resNetrA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc)
                + parseFloat(restaxvalrA)).toFixed(2);
        }
        else {
            restaxvalrA = maths(
                parseFloat(restotJustAfterDiscSumrA),
                parseFloat(subInfo.taxperc),
                "taxval"
            );

            resNetrA = maths(
                parseFloat(restotJustAfterDiscSumrA),
                parseFloat(subInfo.taxperc),
                "Net"
            );
        }

        newData = {
            /* to show */
            unitame: LetvalueCurrUnits.name /*  - الـوحدة name */,
            symbol: subInfo.symbol /*  - إسم الصنف  */,

            /* to maaths */
            /* int - الإجمالي */
            totJust: restotJustSumrA,

            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,
            /* to go */
            currency_from: parseInt(itemId) /* float - id الصنف */,
            unit: parseInt(LetvalueCurrUnits.id) /* int - الـوحدة id */,
            /* float - الكمية */
            val1: resVal1SumrA,
            /* float - العبوة */
            val: parseFloat(subInfo.perc),
            /* float - الـسعر */
            new_exchange_price: parseFloat(isdata[or.i].new_exchange_price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountrA,
            /* float - %  خصم نسبة */

            DiscPers: subInfo.DiscPers,
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(subInfo.taxperc),
            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,
            taxval: restaxvalrA,


            /* float - الصافي */
            netAmountSub: resNetrA,
            barcode: subInfo.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,
        };

        //  alert(newData.netAmountSub)
        const isDataUpdate = [...isdata];
        const index = or.i;
        isDataUpdate[index] = newData;
        setExSub(isDataUpdate.length);
        handSums(isDataUpdate);

        setIsData([...isDataUpdate]);
    };

    const maths = (rTotAfterDic, taxperc, ty) => {

        if (permiCuCo.CWVat == 0 && taxperc != 0) {
            if (ty === "taxval") return ((rTotAfterDic * taxperc) / 100).toFixed(2);
            if (ty === "Net")
                return (rTotAfterDic + (rTotAfterDic * taxperc) / 100).toFixed(2);
            if (ty === "before_vat") return rTotAfterDic.toFixed(2);
        } else if (permiCuCo.CWVat == 1 && taxperc != 0) {
            if (ty === "taxval")
                return (
                    parseFloat(rTotAfterDic) -
                    rTotAfterDic / (1 + taxperc / 100)
                ).toFixed(2);
            if (ty === "Net") return rTotAfterDic.toFixed(2);

            if (ty === "before_vat")
                return (rTotAfterDic - (rTotAfterDic / ((100 + taxperc) / taxperc))).toFixed(2);

        } else if (taxperc == 0) {
            if (ty === "taxval") return (0).toFixed(2);
            if (ty === "Net")
                return (rTotAfterDic).toFixed(2);
            if (ty === "before_vat") return rTotAfterDic.toFixed(2);
        }
    };


    const mathsTab3val = (rTotAfterDic, taxperc, ty) => {
        if (taxperc == 0) {
            return (0).toFixed(2);
        } else {
            return ((rTotAfterDic * taxperc) / 100).toFixed(2);
        }
    };


    const hRowAdd = (newData, resolve) => {
        let errorList = [];
        let restaxvalA = 0,
            resNetA = 0,
            restotJustSumA = 0,
            restotJustAfterDiscSumA = 0,
            resDiscPerA = 0,
            resDisCountA = 0,
            tot_before_vat_with_tab3val = 0,
            tot_befor_vat_after_disc = 0;

        restotJustSumA = parseFloat(subInfo.totJust);
        restotJustAfterDiscSumA =
            parseFloat(subInfo.totJust) - parseFloat(subInfo.discount);

        if (checked.discRateck === true) {
            //  alert('in if')
            resDiscPerA = parseFloat(invDisc.rate);

            resDisCountA = (
                parseFloat(invDisc.rate / 100) * parseFloat(subInfo.totJust)
            ).toFixed(2);
            restotJustAfterDiscSumA =
                parseFloat(subInfo.totJust) - parseFloat(resDisCountA);

        } else if (checked.discMinusck === true) {
            resDiscPerA = (
                (parseFloat(idata.minus) / parseFloat(subInfo.totJust)) *
                100
            ).toFixed(2);
            resDisCountA = (
                parseFloat(resDiscPerA / 100) * parseFloat(subInfo.totJust)
            ).toFixed(2);
        }
        // disc sub level
        else {
            // alert('in else')
            resDiscPerA = parseFloat(subInfo.DiscPers);
            resDisCountA = (
                parseFloat(subInfo.DiscPers / 100) * parseFloat(subInfo.totJust)
            ).toFixed(2);
        }
        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(subInfo.taxperc),
            "before_vat"
        );



        if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
                parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

            let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalA = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(subInfo.taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
        } else {
            restaxvalA = maths(
                parseFloat(restotJustAfterDiscSumA),
                parseFloat(subInfo.taxperc),
                "taxval"
            );

            resNetA = maths(
                parseFloat(restotJustAfterDiscSumA),
                parseFloat(subInfo.taxperc),
                "Net"
            );
        }
        newData = {
            /* to show */
            unitame: LetvalueCurrUnits.name /*  - الـوحدة name */,
            symbol: subInfo.symbol /*  - إسم الصنف  */,
            /* to maaths */
            /* int -  الإجمالي */
            totJust: restotJustSumA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,
            /* to go */

            tot_before_vat_after_d: tot_befor_vat_after_disc,
            // currency_from: parseInt(subInfo.id), /* float - id الصنف */

            tot_before_vat_after_d: tot_befor_vat_after_disc,

            currency_from: parseInt(itemId) /* float - id الصنف */,
            unit: parseInt(LetvalueCurrUnits.id) /* int - الـوحدة id */,
            /* float - الكمية */
            val1: parseFloat(subInfo.val1),
            // new _val1:parseFloat(subInfo.new _val1),
            /* float - العبوة */
            val: parseFloat(subInfo.perc),
            // new _val:parseFloat(subInfo.perc),
            /* float - الـسعر */
            new_exchange_price: parseFloat(subInfo.Price),
            // all_new_exchange_price: parseFloat(subInfo.Price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountA,
            // new _discount: parseFloat(subInfo.discount),
            /* float - %  خصم نسبة */
            DiscPers: resDiscPerA,
            // new _DiscPers: parseFloat(subInfo.DiscPers),
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(subInfo.taxperc),
            // new _taxperc: parseFloat(subInfo.taxperc),
            /* float - إجمالي قيمة المضافة  */
            taxval: restaxvalA,
            // new_taxval: parseFloat((subInfo.totJust-subInfo.discount)*subInfo.taxperc/100),
            /* float - الصافي */
            netAmountSub: resNetA,
            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,
            // netAmo untSub: parseFloat(subInfo.totJust-subInfo.discount) + parseFloat((subInfo.totJust-subInfo.discount)*subInfo.taxperc/100),
            barcode: subInfo.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,
        };
        if (errorList.length < 1) {
            //no error
            let dataToAdd = [...isdata];
            dataToAdd.push(newData);
            setIsData(dataToAdd);
            handSums(dataToAdd);
            setExSub(dataToAdd.length);
        } else {
            resolve();
        }
    };

    const [sums, setSums] = useState(insh.Sums);

    // الدفع المبقي
    const [payment, setPayment] = useState(insh.Payment);
    const [remains, setRemains] = useState(insh.Remains);
    const [isHedden, setIshedden] = useState(false);
    const [isOpenUpdate, setIsOpenUpdate] = useState(false);
    const [invDisc, setInvDisc] = useState(insh.InvDisc);
    const [invsSearchTable, setInvsSearchTable] = useState([]);
    const selectOrderType = [
        { id: 1, name: "local", label: "محلي " },
        { id: 2, name: "Out", label: "سفري" },
        { id: 3, name: "Falmilies", label: "عوائل" },
        { id: 4, name: "Delivery App", label: "تطبيق توصيل" },
        { id: 5, name: "Delivery", label: "توصيل" },
    ];
    const SelectNumber = [
        { value: 1, name: "1", },
        { value: 2, name: "2", },
        { value: 3, name: "3", },
        { value: 4, name: "4", },
        { value: 5, name: "5", },
        { value: 6, name: "6", },
        { value: 7, name: "7", },
        { value: 8, name: "8", },
        { value: 9, name: "9", },
        { value: 10, name: "X", },
        { value: 11, name: "*X", },
    ];
    const optionsOrderTypes = {
        select: selectOrderType[0],
        OrderNo: 0
    };
    const [orderData, setOrderData] = useState(optionsOrderTypes);
    const handSums = (data) => {
        let val1s = 0,
            tot_sale_or_purch = 0,
      /*tot_sales=0,tot_purchs=0,*/ amountOfVats = 0,
            netAmounts = 0,
            amountAfterDiscs = 0,
            amount_after_disc_before_vat = 0,
            discounts = 0,
            amountWithVats = 0,
            tab3Val = 0,
            invTab3Val = 0,
            taxpercs;
        for (var m = 0; m < data.length; m++) {
            val1s += parseFloat(data[m].val1);
            tot_sale_or_purch += parseFloat(data[m].totJust);
            taxpercs = data[m].taxperc;
            /* جمالي القيمة المضافة */
            amountOfVats += parseFloat(data[m].taxval);
            netAmounts += parseFloat(data[m].netAmountSub);
            /* إجمالي قبل الضريبة */
            amountAfterDiscs += parseFloat(data[m].totAfterDisc);
            discounts += parseFloat(data[m].discount);
            invTab3Val += parseFloat(data[m].tab3Val);
            amount_after_disc_before_vat += parseFloat(data[m].totAfterDisc);
        }

        /* في الحالتين */
        /* إجمالي بعد الخصم */
        amountWithVats = (
            parseFloat(tot_sale_or_purch) - parseFloat(discounts)
        ).toFixed(2);

        tab3Val = parseFloat(invTab3Val).toFixed(2);
        /* يشمل */


        if (permiCuCo.CWVat == 1) {
            if (tab3Val > 0) {
                amountAfterDiscs = (
                    parseFloat(amount_after_disc_before_vat)
                ).toFixed(2);
                amountOfVats = (
                    parseFloat(amountOfVats)
                ).toFixed(2);

                netAmounts = (
                    parseFloat(amount_after_disc_before_vat) + parseFloat(amountOfVats) + parseFloat(tab3Val)
                ).toFixed(2);

                amountWithVats = (
                    parseFloat(netAmounts)
                ).toFixed(2);

            } else {
                amountAfterDiscs = (
                    parseFloat(amount_after_disc_before_vat)
                ).toFixed(2);

                amountOfVats = (
                    parseFloat(amountWithVats) - parseFloat(amountAfterDiscs)
                ).toFixed(2);

                netAmounts = (
                    parseFloat(amountWithVats)
                ).toFixed(2);

            }


        } else {
            /*لا يشمل */
            amountAfterDiscs = (
                parseFloat(amount_after_disc_before_vat)
            ).toFixed(2);

            netAmounts = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats) + parseFloat(tab3Val)
            ).toFixed(2);

            amountWithVats = (
                parseFloat(amountAfterDiscs) + parseFloat(amountOfVats) + parseFloat(tab3Val)
            ).toFixed(2);


        }


        setSums({ val1: val1s });
        setIData({
            ...idata,
            amountAfterDisc: amountAfterDiscs,
            amountWithVat: amountWithVats,
            tot_sale: tot_sale_or_purch,
            tot_purch: tot_sale_or_purch,
            netAmount: netAmounts,
            amountBefordisc: tot_sale_or_purch,
            amountOfVat: amountOfVats,
            minus: discounts,
            tab3Val: invTab3Val,
        });

        fcHandSumsToPayment(netAmounts);

        fcHandSumsToinvDisc(tot_sale_or_purch, discounts);
    };

    const fcHandSumsToPayment = (newExPrice) => {
        // screan payment
        if (idata.inv_type == 1) {
            setPayment({ ...payment, stay: newExPrice, paidup: 0 });
            setRemains({ ...remains, cashPart: 0, agelPart: newExPrice, bankPart: 0, networkPart: 0 });
        }
        else {
            setPayment({ ...payment, paidup: newExPrice, stay: 0 });
            if (switchState.cashORnetworksw == false) {
                setRemains({ ...remains, cashPart: newExPrice, agelPart: 0, bankPart: 0, networkPart: 0 });
            } else if (switchState.cashORnetworksw == true) {
                setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: newExPrice });
            }
        }
    };

    const fcHandSumsToinvDisc = (totj, discs) => {
        // قيمة الخصم  مبلغ

        setInvDisc({
            minus: discs,
            rate: (parseFloat(parseFloat(discs) / totj) * 100).toFixed(2),
        });
    };

    const handRowAdd = (or) => {

        if (or.cros === "newRow") {
            hRowAdd();
        } else if (or.cros === "rnewRow") {
            if (permistionInv?.NOREP === true) {
                hRowAdd();
            } else {
                hRowrAdd();
            }

        }
    };

    const pinAutosValue = async (Tbl, id) => {
        if (Tbl === "Safe")
            AutoOptions.Safes.map((x) => {
                if (x.id == id) setValueSafes(x);
            });
        else if (Tbl === "Stock")
            AutoOptions.Stocks.map((x) => {
                if (x.id == id) setValueStock(x);
            });
        else if (Tbl === "omla")
            gets.omlats.map((x) => {
                if (x.id == id) setOmlaValue(x);
            });
        else if (Tbl === "Customer") {
            var res_cust = AutoOptions.Customers.find((obj) => obj.id === id);
            if (res_cust) { setValueCustomers(res_cust); }
            else {
                viewHandleCustomers('', setOptionsCustomers, false, setting.cusType, id, AutoOptions.Customers, setValueCustomers)
            }
        }
        else if (Tbl === "salesmen")
            gets.salesmen.map((x) => {
                if (x.id == id) setValueSalesmen(x);
            });
        else if (Tbl === "costcenters")
            gets.costcenters.map((x) => {
                if (x.id == id) setValueCostcenter(x);
            });
        else if (Tbl === "Bank")
            AutoOptions.Banks.map((x) => {
                if (x.i == id) setValueBank(x);
            });
        else if (Tbl === "BankPMD")
            AutoOptions.Banks.map((x) => {
                if (x.id == id) setValueBankPMD(x);
            });
        else if (Tbl === "Bank2PMD")
            AutoOptions.Banks.map((x) => {
                if (x.id == id) setValueBankTransPMD(x);
            });
        else if (Tbl === "EmployeePMD")
            gets.Employees.map((x) => {
                if (x.id == id) setValueEmployePMD(x);
            });
        else if (Tbl === "ordertype")
            selectOrderType.map((x) => {
                if (x.id == id) setOrderData({ ...orderData, select: x });
            });
        // }).catch(error => { })
    };

    const [numberbarcode, setNumberbarcode] = useState("");
    const [isBarcode, setIsBarcode] = useState(false);
    const [isApiConnect, setIsApiConnect] = useState(true);

    useEffect(() => {
        if (isBarcode) {
            getrowDataCurrencie();
            setNumberbarcode("");
            setIsBarcode(false);
        }
    }, [isBarcode]);




    const getCustomerData = async () => {
        if (valueCustomers?.id == null) {

            alert("ooooo");
        } else {
            await axios
                .get(
                    uri +
                    `RptSales/getCustData?custId=${valueCustomers?.id}`
                )
                .then((res) => {

                    setCustData(res.data?.custData[0]);
                })
                .catch((err) => {
                    toast.error("لا يوجد بيانات لهذا العميل ");
                    console.log(err);
                });

            if (custData != null) {
                handleOpenCustomerData();
            } else {
                toast.error("لا يوجد بيانات لهذا العميل ");
            }
        }
    };
    const clickUpdate = () => {
        setIsOpenUpdate(true);
    };
    const reUpdateCust = async (updateData) => {
        if (updateData != null) {

            var otherOptions = optionsCustomers.filter((obj) => obj.id != updateData.id);
            let newCust = {
                id: updateData.id, name: updateData.name, Cust_inv_type: updateData.Cust_inv_type, acc_no: updateData.acc_no,
                salesmen: updateData.salesmen, CustandSup: updateData.CustandSup, maxdepit: updateData.maxdepit
            };
            setOptionsCustomers([newCust, ...otherOptions]);
            setValueCustomers(newCust);
            await changAutoCustomers(newCust);
        }
        console.log("the oldCurr is ", updateData);
    };

    const transformDone = () => {
        his.replace({
            pathname: `/Invoces`,
            state: transToSal,
        });

        // }, 2000);
        loadGet(
            transToSal.idata.branch,
            transToSal.setting.PrTy_InPr,
            transToSal.idata.create_user,
            transToSal.setting.iformid,
            location.state.stor.invsType
        );

        location.state.setting = transToSal.setting;
        setSetting(location.state.setting);
        location.state.stor = transToSal.stor;
        setStor(location.state.stor);

        setOr({ ...or, postput: "toPost" });
    };


    const showChosedInv = async (t, val) => {
        const tbs = {
            View_Inv_reseloving: true,
            parms: {
                iprocid: val,
                bol1: permiCuCo.CWVat,
                sProTyInvPro: setting.PrTy_InPr,
            },
            autos: {},
        };
        const alt = { View_Inv_reseloving: true };

        const al = Object.entries(alt).reduce((u, [n, v]) => {
            u[`${n}` + `${t ? "t" : ""}`] = v;
            return u;
        }, {});
        const alts = { ...al, ...tbs };
        await axios
            .post(uri + "Res", alts)
            .then((res) => {
                setIData(res.data.inv);
                if (res?.data?.inv?.OrderNo > 0) {
                    setMaxOrderNo(res?.data?.inv?.OrderNo ?? 0);
                    pinAutosValue("ordertype", res?.data?.inv?.OrderNoType);
                }
                console.log("the res data inve is", res.data.inv);
                // .then(resSub => {
                // setIsData(res.data.invS);
                const dataItems = res.data.invS.map((row, i) => {
                    return {
                        ...row,
                        UnitsTable: [],
                        defUnit: {},
                        no: i,
                        editAbleVal: false,
                        editAblePrice: false,
                        editAbleUnit: false,
                        editAbleTax: false,
                        editAbleDescM: false,
                        editAbleDescP: false,
                        editAbleDescNote: false,
                        tab3val_sub: row?.tab3Val ?? 0,
                        Qtys: 0,
                        tab3Val: row?.tab3Val ?? 0,
                        type: 1,

                    };
                });

                setIsData(dataItems);
                setPayment({
                    ...payment,
                    paidup: res.data.inv?.Pay_mouny,
                    stay: res.data.inv?.Remaining,
                });
                setRemains({
                    ...remains,
                    cashPart: res.data.inv?.cash_part,
                    agelPart: res.data.inv?.agel_part,
                    networkPart: res.data.inv?.network_part,
                    bankPart: res.data.inv?.bank_part,
                    empPart: res.data.inv?.emp_part,
                });
                setSums({
                    ...sums,
                    val1: res.data.invS.reduce(
                        (totalVal1, sub) => totalVal1 + sub.val1,
                        0
                    ),
                });

                res.data.inv.inv_type === 1
                    ? setValueType(AutoOptions.types[0])
                    : setValueType(AutoOptions.types[1]);
                pinAutosValue("Safe", res.data.inv.safe);

                pinAutosValue("Stock", res.data.inv.stock);
                pinAutosValue("Customer", res.data.inv.cust_id);
                /* Autos options */
                if (res.data.inv.salesman != -1)
                    pinAutosValue("salesmen", res.data.inv.salesman);
                else {
                    setValueSalesmen(AutoOptions?.salesuser);
                }
                if (res.data.inv.center != -1)
                    pinAutosValue("costcenter", res.data.inv.center);
                else {
                    setValueCostcenter(insh.Auto);
                }
                let letNetworkck = false,
                    letCashck = false,
                    letcashORnetworksw = false;
                if (res.data.inv.pay_type === 1) {
                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                }
                else if (res.data.inv.pay_type === 2) {
                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.cash_part) > 0) {
                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                }
                else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.network_part) > 0) {
                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });

                    setValueBank(res.data.inv.bank);
                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type === -1 && res.data.inv.Pay_mouny === 0) {
                    // setValueStock(AutoOptions.Stocks[0]);
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }
                else {
                    // setValueStock(AutoOptions.Stocks[0]);
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }

                setInfoInv({
                    id: res.data.inv.id,
                    InvId_Return:
                        res.data.inv.InvId_Return != null
                            ? res.data.inv.InvId_Return
                            : infoInv.InvId_Return,
                });

                /* ======= S in PMD ======= */
                /* checked AND Autos */
                let cash_p = false,
                    network_p = false,
                    agel_p = false,
                    bank_p = false,
                    emp_p = false;

                if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
                    cash_p = true;
                }

                if (
                    res.data.inv.network_part !== null ||
                    res.data.inv.network_part === 0
                ) {
                    // g etAutosOptions('Bank',res.data.inv.bank,'NWinPMD');
                    pinAutosValue("BankPMD", res.data.inv.bank);
                    network_p = true;
                } else {
                    setValueBankPMD(insh.AutoBank);
                }

                if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
                    agel_p = true;
                }

                if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
                    // g etAutosOptions('Bank',res.data.inv.bank,'Bk2inPMD');
                    pinAutosValue("Bank2PMD", res.data.inv.bank);
                    bank_p = true;
                }

                if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
                    // g etAutosOptions('Employee',res.data.inv.emp,'EmpinPMD');
                    pinAutosValue("EmployeePMD", res.data.inv.emp);
                    emp_p = true;
                }

                setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
                setChecked({
                    ...checked,

                    // in UP
                    cashck: letCashck,
                    networkck: letNetworkck,
                    // in PMD
                    cash_partck: cash_p,
                    network_partck: network_p,
                    agel_partck: agel_p,
                    bank_partck: bank_p,
                    emp_partck: emp_p,
                });

                /* ======= E in PMD ======= */
                // set discount values
                fcHandSumsToinvDisc(res.data.inv?.amountBefordisc, res.data.inv?.minus);
                setRowUpdate({});
                handCloseDw();
                setValue(0);

            })
            .catch((error) => {
                /*console.log('no res');*/
            });
    };

    const showChosedInvt = async (t, val) => {
        const tbs = { parms: { iprocid: val, bol1: permiCuCo.CWVat }, autos: {} };
        const alt = { View_Inv_reseloving: true };
        const al = Object.entries(alt).reduce((u, [n, v]) => {
            u[`${n}` + `${t ? "t" : ""}`] = v;
            return u;
        }, {});
        const alts = { ...al, ...tbs };

        //  console.log('__tb--')
        //  console.log(tb)
        await axios
            .post(uri + "Res", alts)
            .then((res) => {
                //console.log('res.data'); console.log(res.data);

                setIData(res.data.inv);
                // setIsData(res.data.invS);
                const dataItems = res.data.invS.map((row, i) => {
                    return {
                        ...row,
                        UnitsTable: [],
                        defUnit: {},
                        no: i,
                        editAbleVal: false,
                        editAblePrice: false,
                        editAbleUnit: false,
                        editAbleTax: false,
                        editAbleDescM: false,
                        editAbleDescP: false,
                        editAbleDescNote: false,
                        tab3val_sub: row?.tab3Val ?? 0,
                        Qtys: 0,
                        tab3Val: row?.tab3Val ?? 0,
                        type: 1,

                    };
                });

                setIsData(dataItems);
                // .then(resSub => {
                setPayment({
                    ...payment,
                    paidup: res.data.inv?.Pay_mouny,
                    stay: res.data.inv?.Remaining,
                });
                setRemains({
                    ...remains,
                    cashPart: res.data.inv?.cash_part,
                    agelPart: res.data.inv?.agel_part,
                    networkPart: res.data.inv?.network_part,
                    bankPart: 0,
                });
                setSums({
                    ...sums,
                    val1: res.data.invS.reduce(
                        (totalVal1, sub) => totalVal1 + sub.val1,
                        0
                    ),
                });
                setStor({ ...stor, comt: val });
                res.data.inv.inv_type == 1
                    ? setValueType(gets.types[0])
                    : setValueType(gets.types[1]);
                pinAutosValue("Safe", res.data.inv.safe);
                pinAutosValue("Stock", res.data.inv.stock);
                pinAutosValue("Customer", res.data.inv.cust_id);


                /* Autos options */
                if (res.data.inv.salesman != -1)
                    pinAutosValue("salesmen", res.data.inv.salesman);
                else {
                    setValueSalesmen(insh.Auto);
                }
                if (res.data.inv.center != -1)
                    pinAutosValue("costcenter", res.data.inv.center);
                else {
                    setValueCostcenter(insh.Auto);
                }
                let letNetworkck = false,
                    letCashck = false,
                    letcashORnetworksw = false;
                if (res.data.inv.pay_type == 1) {
                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;

                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                } else if (res.data.inv.pay_type == 2) {
                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                    setLbl({ ...lbl, chashNetwork: transForm("network") });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type == -1 && res.data.inv.cash_part > 0) {
                    setValueBank(insh.AutoBank);
                    letCashck = true;
                    letcashORnetworksw = false;
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: false,
                        DeleIcon: true,
                    });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                }
                else if (res.data.inv.pay_type == -1 && res.data.inv.network_part > 0) {
                    letNetworkck = true;
                    letcashORnetworksw = true;
                    setUiElement({ ...uiElement, bank: false, DeleIcon: true });
                    const text = transForm("network").toString();
                    setLbl({ ...lbl, chashNetwork: text });
                    pinAutosValue("Bank", res.data.inv.bank);
                }
                else if (res.data.inv.pay_type == -1 && res.data.inv.Pay_mouny == 0) {
                    setValueStock(insh.Auto);
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }


                else {
                    setValueStock(insh.Auto);
                    setUiElement({
                        ...uiElement,
                        bank: true,
                        payMethod: true,
                        stock: true,
                        DeleIcon: true,
                    });
                    setValueBank(insh.AutoBank);
                }
                setInfoInv({
                    id: res.data.inv.id,
                    InvId_Return:
                        res.data.inv.InvId_Return != null
                            ? res.data.inv.InvId_Return
                            : infoInv.InvId_Return,
                });

                /* ======= S in PMD ======= */
                /* checked AND Autos */
                let cash_p = false,
                    network_p = false,
                    agel_p = false,
                    bank_p = false,
                    emp_p = false;

                if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
                    cash_p = true;
                }

                if (
                    res.data.inv.network_part !== null ||
                    res.data.inv.network_part === 0
                ) {
                    pinAutosValue("BankPMD", res.data.inv.bank);
                    network_p = true;
                } else {
                    setValueBankPMD(insh.AutoBank);
                }

                if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
                    agel_p = true;
                }

                if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
                    pinAutosValue("Bank2PMD", res.data.inv.bank);
                    bank_p = true;
                }

                if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
                    pinAutosValue("EmployeePMD", res.data.inv.emp);
                    emp_p = true;
                }

                setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
                setChecked({
                    ...checked,

                    // in UP
                    cashck: letCashck,
                    networkck: letNetworkck,
                    // in PMD
                    cash_partck: cash_p,
                    network_partck: network_p,
                    agel_partck: agel_p,
                    bank_partck: bank_p,
                    emp_partck: emp_p,
                });

                /* ======= E in PMD ======= */
                handCloseDwt();
                setValue(0);
                setRowUpdate({});

            })
            .catch((error) => {
                /*console.log('no res');*/
            });
    };
    const [voucherDialog, setVoucherDialog] = useState({
        isOpen: false,
        data: "",
        onSucsess: "",
        onEnd: ""
    });

    const changPayment = (prop) => (event) => {

        if (prop === "paidup") {

            let total = (parseFloat(idata.netAmount) - event.target.value).toFixed(2);
            // toDiloag
            payment.paidupPMDcn = event.target.value;
            payment.stayPMDcn = payment.stay;
            setPayment({ ...payment, paidup: event.target.value, stay: total });
            setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

            if (valueType.id === 1) {

                if (switchState.cashORnetworksw == false) {
                    setUiElement({
                        ...uiElement,
                        stock: false,
                        payMethod: false,
                        bank: true,
                    });

                    setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

                    const reet = reInshAuto(0, "");
                    setValueBank(reet);
                    setValueStock(AutoOptions.Stocks[0]);
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });
                } else if (switchState.cashORnetworksw == true) {
                    setRemains({ ...remains, cashPart: 0, agelPart: total, bankPart: 0, networkPart: event.target.value });

                    setUiElement({
                        ...uiElement,
                        stock: true,
                        payMethod: false,
                        bank: false,
                    });

                    setSwitchState({ ...switchState, cashORnetworksw: true });
                    setLbl({ ...lbl, chashNetwork: transForm("network") });
                }
                else {
                    setUiElement({
                        ...uiElement,
                        stock: false,
                        payMethod: false,
                        bank: true,
                    });

                    setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

                    const reet = reInshAuto(0, "");
                    setValueBank(reet);
                    setValueStock(AutoOptions.Stocks[0]);
                    setSwitchState({ ...switchState, cashORnetworksw: false });
                    setLbl({ ...lbl, chashNetwork: transForm("cash") });

                }


            }

        } else if (prop === "paidupPMDcn") {
            payment.stayPMDcn = (
                event.target.value - parseFloat(idata.netAmount)
            ).toFixed(2);
            setPayment({ ...payment, [prop]: event.target.value });
        }
    };

    const MathChckedIdata = (prop, val) => {
        let res = Number(val);
        res += idata.cash_part;
        setIData({ ...idata, [prop]: "", cash_part: res });
    };

    const MathChangIdata = (prop, val) => {
        let ii = {
            totinv: Number(idata.netAmount),
            res: Number(val),
            sum: Number(0),
        };
        let i = {
            cashPart: Number(remains.cashPart),
            networkPart: Number(remains.networkPart),
            agelPart: Number(remains.agelPart),
            bankPart: Number(remains.bankPart),
            empPart: Number(remains.empPart),
        };
        let kind = "";
        const otherField = Object.keys(i).filter((f) => f !== prop);
        const remainaing = ii.totinv - ii.res;
        let newValue = { ...i, [prop]: ii.res };
        if (parseFloat(remainaing) < 0) {
            if (remains.isAgel == true && parseFloat(remains.agelPart) > 0 && prop !== "agelPart") {
                newValue[prop] = 0;
                otherField.forEach((f) => (newValue[f] = 0));
                newValue["agelPart"] = ii.totinv;
            } else {
                newValue[prop] = ii.totinv;
                otherField.forEach((f) => (newValue[f] = 0));
            }
        } else {
            newValue[prop] = ii.res;
            if (switchState.cashORnetworksw == false && remains.isCash == true &&
                remains.isAgel == false && prop !== "cashPart") {
                const cashFeild = Object.keys(i).filter((f) => f !== prop && f !== "cashPart");
                let sumOthers = cashFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                newValue["cashPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
            }
            else if (switchState.cashORnetworksw === true && remains.isNetwork == true
                && remains.isAgel == false && prop !== "networkPart") {
                const networkFeild = Object.keys(i).filter((f) => f !== prop && f !== "networkPart");
                let sumOthers = networkFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                newValue["networkPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
            } else if (remains.isAgel == true && parseFloat(remains.agelPart) > 0 && prop !== "agelPart") {
                const agelFeild = Object.keys(i).filter((f) => f !== prop && f !== "agelPart");
                let sumOthers = agelFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
                if (ii.res >= ii.totinv) {
                    newValue[prop] = 0;
                    newValue["agelPart"] = ii.totinv.toFixed(2);
                } else {
                    newValue["agelPart"] = (ii.totinv - (ii.res) - parseFloat(sumOthers)).toFixed(2);
                }
            }
        }
        let all = parseFloat(newValue.cashPart) + parseFloat(newValue.agelPart) +
            parseFloat(newValue.bankPart) + parseFloat(newValue.empPart) + parseFloat(newValue.networkPart);
        if (prop === "bankPart" && (idata.bank2 == -1 || idata.bank2 == 0)) {
            idata.bank2 = AutoOptions.Banks[0].id;
        } else if (prop === "networkPart" && (idata.bank == -1 || idata.bank == 0)) {
            idata.bank = AutoOptions.Banks[0].id;
        };

        let payMony = (parseFloat(newValue.bankPart) + parseFloat(newValue.cashPart) + parseFloat(newValue.networkPart) +
            parseFloat(newValue.empPart)).toFixed(2);
        let raimMony = (parseFloat(idata.netAmount) - parseFloat(payMony)).toFixed(2);
        setPayment({ ...payment, paidup: payMony ?? 0, stay: raimMony ?? 0 });
        if (parseFloat(newValue.agelPart) == 0 && valueType.id === 1) { idata.inv_type = 2; setValueType(AutoOptions.types[1]); }

        if (parseFloat(newValue.cashPart) === 0 && idata.pay_type === 1 && (parseFloat(newValue.networkPart) > 0 || parseFloat(newValue.bankPart) > 0)) {
            idata.pay_type = 2; uiElement.bank = false; uiElement.stock = false; uiElement.payMethod = false;
            const text = transForm("network").toString();
            lbl.chashNetwork = text;
        } else if (parseFloat(newValue.cashPart) === parseFloat(idata.netAmount) && idata.pay_type !== 1) {
            idata.pay_type = 1; idata.inv_type = 2; uiElement.bank = false; uiElement.stock = false; uiElement.payMethod = false;
            const text = transForm("network").toString();
            lbl.chashNetwork = text;
        } else if (parseFloat(newValue.agelPart) > 0 && idata.inv_type !== 1 && idata.pay_type !== -1) {
            idata.inv_type = 1; idata.pay_type = -1; setValueType(AutoOptions.types[0]);
        }

        setRemains({
            ...remains,
            agelPart: newValue.agelPart,
            bankPart: newValue.bankPart,
            cashPart: newValue.cashPart,
            networkPart: newValue.networkPart,
            empPart: newValue.empPart,
            isCash: parseFloat(newValue.cashPart) > 0 ? true : false,
            isAgel: parseFloat(newValue.agelPart) > 0 ? true : false,
            isNetwork: parseFloat(newValue.networkPart) > 0 ? true : false,
            isBank: parseFloat(newValue.bankPart) > 0 ? true : false,
            isEmp: parseFloat(newValue.empPart) > 0 ? true : false,
            allpart: all,
        });
    };
    const changIdata = (prop) => (event) => {
        if (prop === "cashPart" && remains.isCash === true) {
            MathChangIdata(prop, event.target.value);
        } if (prop === "networkPart" && remains.isNetwork === true) {
            MathChangIdata(prop, event.target.value);
        } else if (prop === "agelPart" && remains.isAgel === true) {
            MathChangIdata(prop, event.target.value);
        } else if (prop === "bankPart" && remains.isBank === true) {
            MathChangIdata(prop, event.target.value);
        }
        else if (prop === "empPart" && remains.isEmp === true) {
            MathChangIdata(prop, event.target.value);
        }
        else if (prop == "check_refno" && remains.isBank == true) {
            toDoIdata(prop, event.target.value);
        } else if (prop == "refno") {
            toDoIdata(prop, event.target.value);
        } else if (prop == "date") {
            toDoIdata(prop, event.target.value);
        } else if (prop == "notes") {
            toDoIdata(prop, event.target.value);
        } else {
            toDoIdata(prop, event.target.value);
        }
    };
    const getCodeDiscount = async (props) => {
        if (idata?.Dis_Code!==null &&idata?.Dis_Code!==""){
            await axios.get(uri + `DiscountCode?code=${idata?.Dis_Code}&&Fdate=${idata?.date}`).then(res => {
                if(res.data?.type==2){
                    changinvDiscCode("rate",res.data?.rate);
                  }else{
                    changinvDiscCode("minus",res.data?.monay);
                  }
            }).catch(err => {
                alert(err);
            });
        }else{
            alert("check you write Discount Code");
        }
    };

    const changinvDiscCode = (prop, value) => {
        let ret = null,
            evenTargetValue = null;
        let val = Number(value);

        if (isdata.length !== 0) {
            if (prop === "minus") {
                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                    evenTargetValue = (
                        (val * 100) /
                        parseFloat(idata.tot_sale)
                    ).toFixed(2);
                else
                    evenTargetValue = (
                        (val * 100) /
                        parseFloat(idata.tot_purch)
                    ).toFixed(2);

                if (permistionInv.SDV !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(val),
                        permistionInv.SDV,
                        "DiscC"
                    );
                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDP, "DiscP");
                if (ret === "") {
          /*invDisc.rate='';*/ afterGetCurrMathRate(0);
                } else {
                    afterGetCurrMathRate(evenTargetValue);
                }
            } else if (prop === "rate") {
                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                    evenTargetValue = (
                        parseFloat(idata.tot_sale) *
                        (val / 100)
                    ).toFixed(2);
                else
                    evenTargetValue = (
                        parseFloat(idata.tot_purch) *
                        (val / 100)
                    ).toFixed(2);

                if (permistionInv.SDP !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(val),
                        permistionInv.SDP,
                        "DiscP"
                    );
                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDV, "DiscC");
                if (ret === "") {
                    afterGetCurrMathRate(0);
                } else {
                    afterGetCurrMathRate(val);
                }
            }
        }
        prop === "minus"
            ? setInvDisc({
                ...invDisc,
                [prop]: val,
                rate: evenTargetValue,
            })
            : setInvDisc({
                ...invDisc,
                [prop]: val,
                minus: evenTargetValue,
            });
    };


    const changinvDisc = (prop) => (event) => {
        let ret = null,
            evenTargetValue = null;
        if (isdata.length !== 0) {
            if (prop === "minus") {
                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                    evenTargetValue = (
                        (event.target.value * 100) /
                        parseFloat(idata.tot_sale)
                    ).toFixed(2);
                else
                    evenTargetValue = (
                        (event.target.value * 100) /
                        parseFloat(idata.tot_purch)
                    ).toFixed(2);

                if (permistionInv.SDV !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(event.target.value),
                        permistionInv.SDV,
                        "DiscC"
                    );
                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDP, "DiscP");
                if (ret === "") {
                    event.target.value = "";
          /*invDisc.rate='';*/ afterGetCurrMathRate(0);
                } else {
                    afterGetCurrMathRate(evenTargetValue);
                }
            } else if (prop === "rate") {
                if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
                    evenTargetValue = (
                        parseFloat(idata.tot_sale) *
                        (event.target.value / 100)
                    ).toFixed(2);
                else
                    evenTargetValue = (
                        parseFloat(idata.tot_purch) *
                        (event.target.value / 100)
                    ).toFixed(2);

                if (permistionInv.SDP !== 0)
                    ret = retPrmiSDPandSDV(
                        parseFloat(event.target.value),
                        permistionInv.SDP,
                        "DiscP"
                    );
                else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDV, "DiscC");
                if (ret === "") {
                    event.target.value = "";
          /*idata.minus='';*/ afterGetCurrMathRate(0);
                } else {
                    afterGetCurrMathRate(event.target.value);
                }
            }
        }
        prop === "minus"
            ? setInvDisc({
                ...invDisc,
                [prop]: event.target.value,
                rate: evenTargetValue,
            })
            : setInvDisc({
                ...invDisc,
                [prop]: event.target.value,
                minus: evenTargetValue,
            });
    };

    const afterGetCurrMathRate = (rate) => {
        const isdataU = [...isdata];
        if (rate === "") rate = 0;
        for (let m = 0; m < isdata.length; m++) {
            isdataU[m].DiscPers = rate;
            isdataU[m].barcode = isdata[m].barcode;
            isdataU[m].currency_from = isdata[m].currency_from;
            isdataU[m].discount = ((isdata[m].totJust * rate) / 100).toFixed(2);
            isdataU[m].new_exchange_price = isdata[m].new_exchange_price;
            isdataU[m].sub_branch = isdata[m].sub_branch;
            isdataU[m].sub_center = isdata[m].sub_center;
            isdataU[m].symbol = isdata[m].symbol;
            isdataU[m].tot_before_vat_after_d =
                isdata[m].totJust - parseFloat(isdataU[m].discount);
            isdataU[m].taxperc = isdata[m].taxperc;
            isdataU[m].tab3Val = subInfo?.is_tab3_curr == 1 ? parseFloat(isdataU[m].tot_before_vat_after_d) : 0;
            /* from samer */
            isdataU[m].taxval = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "taxval"
            );
            isdataU[m].netAmountSub = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "Net"
            );
            /* from me */
            isdataU[m].totAfterDisc = maths(
                parseFloat(isdataU[m].tot_before_vat_after_d),
                parseFloat(isdataU[m].taxperc),
                "before_vat"
            );

            isdataU[m].totJust = isdata[m].totJust;
            isdataU[m].unit = isdata[m].unit;
            isdataU[m].unitame = isdata[m].unitame;
            isdataU[m].val = isdata[m].val;
            isdataU[m].val1 = isdata[m].val1;
        }

        handSums(isdataU);
        setIsData([...isdataU]);
    };

    /* s toggle btn */

    //------Rest Options //
    const RestOptonsValue = {
        OrderNo: '',
        OrderTypeE: '',
        OrderTypeA: '',
        OrderNoType: '',
        tawla_group_no: '',
        tawla_group_name: '',
        tawla_no: '',
        tawla_name: '',
        DeliveryTime: '',
        DeliveryEmp: '',
    };
    const [restOptions, setRestOptions] = useState(RestOptonsValue);

    //------Rest Options //
    const [toggle, setToggle] = React.useState(null);

    const clickOpenToggle = (event) => {
        if (isdata.length !== 0) {
            setToggle(event.currentTarget);
        } else {
            handOSnack({
                vertical: "top",
                horizontal: "right",
                severit: "warning",
                text: "يجب تنزيل اصناف أو إختيار فاتورة",
                time: 2000,
            });
        }
    };

    const clickCloseToggle = () => {
        setToggle(null);
    };
    /* e toggle btn */

    // ========================================== s date
    const [dateFrom, setDateFrom] = useState(() => {
        let today = new Date();
        return new moment(today.setDate(today.getDate() - 1)).format("YYYY-MM-DD");
    });
    const [dateTo, setDateTo] = useState(() => {
        let today = new Date();
        return new moment(today.setDate(today.getDate())).format("YYYY-MM-DD");
    });
    const [timeFrom, setTimeFrom] = useState(
        moment(new Date()).startOf("day").format("HH:mm")
    );
    const [timeTo, setTimeTo] = useState(
        moment(new Date()).endOf("day").format("HH:mm")
    );
    /* 'error' 'warning' 'info' 'success'
       'top' 'bottom' 'center' 'left' 'right' */
    const [snack, setSnack] = React.useState(insh.Snack);
    let isSave = permistionInv?.ISSAVE == null ? true : permistionInv?.ISSAVE;

    const { vertical, horizontal, openSnak } = snack;
    const SearchActivityReports = {
        barcode: '',
        curr: {},
        symbol: '',
        barcodeS: '',
        groupS: { id: -1, name: "الكل ", parentId: -1 },
        groupSe: { id: -1, name: "الكل ", parentId: -1 },
        group: { id: -1, name: "الكل", parentId: -1 },
        currS: {}

    };
    const [rptParams, setRptParams] = useState(SearchActivityReports);
    const valueBranch = AutoOptions.Branches.find((obj) => obj.id === sto.branchi);
    const [rptParamsSearch, setRptParamsSearch] = React.useState({
        ...defualtValueSearch,
        user: AutoOptions?.Users[0], branch: valueBranch,
        selectTime: selectDateOrTime[0],
    });
    const [code, setCode] = useState([]);

    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

        if (permistionInv?.USEMEZAN === true) {
            getBarcodeMezan(rptParams?.barcode);
        } else {
            getBarcodeMulti(rptParams?.barcode);
        }

    };

    const getBarcodeMezan = async (itemcode) => {
        let item = null;
        let mezan = null;
        let ibance = null;
        let units = null;
        let defaultUnits = null;
        if (itemcode == "null") {

        } else {
            await axios
                .get(
                    uri +
                    `RptSales/ItemsCodesMezan?currCode=${itemcode}
            &&emp=${sto.empi}&&safe=${valueSafes.id}`
                )
                .then((res) => {

                    defaultUnits = res.data?.unitsSub.find((x) => x.unit === res.data?.barcodes[0].unit);
                    units = res.data?.unitsSub;
                    item = res.data?.barcodes[0];
                    mezan = res.data?.mezan[0];
                    ibance = res.data?.balance[0].Qtys ?? 0;
                })
                .catch((err) => {
                    if (item == null) {
                        getcustitem(itemcode);
                    }
                    console.log(err);
                });
            if (item != null) {
                let totValbef = 0.0;
                for (let m = 0; m < isdata.length; m++) {
                    if (item.curr == isdata[m].currency_from)
                        totValbef += (isdata[m].val1 * isdata[m].val);
                };
                let oldVal = Number(ibance) - totValbef;
                setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
                if (permistionInv.SIM == false &&
                    oldVal < 1 &&
                    (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                    alert(
                        `
            الكمية المدخلة للصنف أكبر من رصيد المخزن
            الكمية الاجمالية المدخلة : ${(parseFloat(1) * parseFloat(item?.perc)) + oldVal
                        }
            رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                        }
            `
                    );
                } else {
                    await barcodeaddMezan({ ...item }, { ...mezan }, { ...defaultUnits }, units, ibance);

                }
            } else {
                toast.error("لا يوجد صنف لهذا الباركود");
            }
        }
    };

    const barcodeaddMezan = (dataCode, mezan, defaultUnits, units, ibance) => {
        setRowUpdate({});
        let pricei = 0.0;
        let totJust = 0.0;
        let taxval = 0.0;
        let taxperc = 0.0;
        let diaperc = 0.0;
        let dismount = 0.0;
        let valperc = 0.0;
        let tot_before_vat_with_tab3val = 0.0;

        if (setting.PrTy_InPr === "22") {
            taxperc = 0.0;
            pricei = parseFloat(dataCode?.purch).toFixed(2);
        } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
            pricei = mezan.isMizan === true && mezan.usePrice === true ? parseFloat(mezan.price) : parseFloat(dataCode?.sale);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        }
        else {
            pricei = parseFloat(dataCode?.purch);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        };
        if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
            if (valueCustomers?.disc_perc > 0) {
                dataCode.discount = valueCustomers?.disc_perc;
                dataCode.amount_disc = 0;
            } else if (valueCustomers?.discount > 0) {
                dataCode.discount = 0;
                dataCode.amount_disc = valueCustomers?.discount;
            }
        }

        let valQ = (mezan.isMizan === true && mezan.usePrice === false) ? parseFloat(mezan.val1) : parseFloat(1);

        totJust = (parseFloat(pricei) * parseFloat(valQ)).toFixed(2);
        taxval = ((parseFloat(totJust) * parseFloat(dataCode.tax)) / 100).toFixed(2);


        let i = {
            amount_disc: Number(dataCode.amount_disc),
            discount: Number(dataCode.discount),
        };
        diaperc = (parseFloat(i.discount)).toFixed(2);
        dismount = (parseFloat(i.amount_disc)).toFixed(2);

        if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
        valperc = (parseFloat(dataCode.perc)).toFixed(2);


        let errorList = [];
        let restaxvalA = 0,
            resNetA = 0,

            restotJustSumA = 0,
            restotJustAfterDiscSumA = 0,
            resDiscPerA = 0,
            resDisCountA = 0,
            tot_befor_vat_after_disc = 0;

        restotJustSumA = parseFloat(totJust);

        if (permistionInv.DSOB == true) {
            if (checked.discRateck === true) {
                //  alert('in if')
                resDiscPerA = parseFloat(invDisc.rate);
                resDisCountA = (
                    parseFloat(invDisc.rate / 100) * parseFloat(totJust)
                ).toFixed(2);

                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(resDisCountA);
            } else if (checked.discMinusck === true) {
                resDiscPerA = (
                    (parseFloat(idata.minus) / parseFloat(totJust)) *
                    100
                ).toFixed(2);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(totJust)
                ).toFixed(2);
            }

        } else {
            if (diaperc > 0) {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);
                resDiscPerA = parseFloat(diaperc);
                resDisCountA = (
                    parseFloat(diaperc / 100) * parseFloat(totJust)
                ).toFixed(2);

            } else if (dismount > 0) {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);

                let desc_perc = (
                    (dismount * 100) /
                    parseFloat(totJust)
                );
                resDiscPerA = parseFloat(desc_perc);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(totJust)
                ).toFixed(2);

            } else {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);
                resDiscPerA = parseFloat(diaperc);
                resDisCountA = (
                    parseFloat(diaperc / 100) * parseFloat(totJust)
                ).toFixed(2);
            }
        }



        restotJustAfterDiscSumA =
            parseFloat(totJust) - parseFloat(resDisCountA);


        restaxvalA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "taxval"
        );

        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "before_vat"
        );


        resNetA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "Net"
        );

        if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
                parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

            let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalA = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
        }

        dataCode = {
            /* to show */
            minPrice: dataCode.mPrice,
            PricePu: dataCode.purch,
            unitame: dataCode.unitName /*  - الـوحدة name */,
            symbol: dataCode.symbol /*  - إسم الصنف  */,
            /* to maaths */
            /* int -  الإجمالي */
            totJust: restotJustSumA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,
            sale_price: mezan.isMizan === true ? parseFloat(mezan.price) : parseFloat(dataCode?.sale),

            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,

            /* to go */
            // currency_from: parseInt(subInfo.id), /* float - id الصنف */
            currency_from: parseInt(dataCode.curr) /* float - id الصنف */,
            unit: parseInt(dataCode.unit) /* int - الـوحدة id */,
            /* float - الكمية */
            val1: parseFloat(valQ),
            // new _val1:parseFloat(subInfo.new _val1),
            /* float - العبوة */
            val: parseFloat(valperc),
            // new _val:parseFloat(subInfo.perc),
            /* float - الـسعر */
            new_exchange_price: parseFloat(pricei),
            // all_new_exchange_price: parseFloat(subInfo.Price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountA,
            /* float - %  خصم نسبة */
            DiscPers: resDiscPerA,
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(taxperc),
            /* float - إجمالي قيمة المضافة  */
            taxval: parseFloat(restaxvalA),
            netAmountSub: (parseFloat(restaxvalA) + parseFloat(tot_befor_vat_after_disc)).toFixed(2),
            barcode: mezan.isMizan === true ? parseFloat(mezan.itemBarcode) : dataCode.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,

            unitame: dataCode.unitName,
            sale_price: parseFloat(dataCode.sale),
            // DiscPers: parseFloat(diaperc),
            // discount: parseFloat(dataCode.amount_disc),
            discount: resDisCountA,
            DiscPers: resDiscPerA,
            taxperc: parseFloat(taxperc),
            UnitsTable: units,
            defUnit: defaultUnits,
            no: isdata?.length,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            Qtys: ibance,
            type: dataCode.ctype,
        };
        if (errorList.length < 1) {
            //no error
            let add = 0;

            const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
                && obj.new_exchange_price === dataCode.new_exchange_price);

            if (permistionInv?.NOREP === true) {
                let dataToAdd = [...isdata];
                dataToAdd.push(dataCode);
                setIsData(dataToAdd);
                handSums(dataToAdd);
                setExSub(dataToAdd.length);
                add = 1;

            }
            else {
                if (updateItem?.no != null && mezan.isMizan === false) {
                    let add = 1;
                    let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
                    if (!isNaN(multiplier)) {

                        let tot = parseFloat(multiplier * updateItem.new_exchange_price);

                        let desc_mount = (
                            parseFloat(tot) *
                            (updateItem.DiscPers / 100)
                        );
                        let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

                        let taxMount = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "taxval"
                        );
                        let betTax = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "before_vat"
                        );

                        let resNetA = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "Net"
                        );
                        if (parseFloat(updateItem?.tab3val_sub) > 0 && permistionInv?.USETOBACO) {
                            let tot_before_new = maths(
                                parseFloat(pricei),
                                parseFloat(updateItem.taxperc),
                                "before_vat"
                            );
                            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

                            let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                            taxMount = mathsTab3val(
                                parseFloat(tot_before),
                                parseFloat(updateItem.taxperc),
                                "taxval"
                            );

                            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                                + parseFloat(taxMount)).toFixed(2);
                        }
                        const newData = {
                            ...updateItem,
                            val1: multiplier,
                            totJust: tot,
                            totAfterDisc: betTax,
                            taxval: taxMount,
                            netAmountSub: resNetA,
                            discount: desc_mount,
                            tab3val_sub: tot_before_vat_with_tab3val,
                            tab3Val: tot_before_vat_with_tab3val,
                        };

                        const index = updateItem?.no;
                        const dataUpdate = [...isdata];
                        dataUpdate[index] = { ...newData };
                        setIsData([...dataUpdate]);
                        handSums(dataUpdate);
                    }
                } else {
                    let dataToAdd = [...isdata];
                    dataToAdd.push(dataCode);
                    setIsData(dataToAdd);
                    handSums(dataToAdd);
                    setExSub(dataToAdd.length);
                    add = 1;

                }

            }
        } else {
            // resolve();
        }
    };

    const getBarcodeMulti = async (itemcode) => {
        let item = null;
        let ibance = 0.0;
        let units = null;
        let defaultUnits = null;
        setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
        // setLastLtem(true);
        if (itemcode == "null") {
        } else {

            if (stor.invsType === 7) {
                await axios
                    .get(
                        uri +
                        `RptSales/CurrCodesMake?currCode=${itemcode}
            &&emp=${sto.empi}&&safe=${valueSafes.id}`
                    )
                    .then((res) => {
                        item = res.data?.barcodes[0];
                        units = res.data?.unitsSub;
                        defaultUnits = res.data?.unitsSub.find((x) => x.unit === res.data?.barcodes[0].unit);
                        units = res.data?.unitsSub;
                        ibance = res.data?.balance[0].Qtys ?? 0;
                    })
                    .catch((err) => {
                        toast.error("لا يوجد صنف لهذا الباركود");
                        console.log(err);
                    });
                if (item != null) {
                    const newItem = localCashe.find((obj) => obj.item.barcode.toString() === item.barcode.toString());
                    if (!newItem) {
                        const addNewItem = { item: item, unit: defaultUnits, val: ibance, units: units, }
                        setLocalCashe([...localCashe, addNewItem]);
                    }
                    setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
                    // setAllowKeyboard(true);
                    await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
                    setIsBarcode(true);
                } else {
                    // toast.error("لا يوجد صنف لهذا الباركود");
                    alert(
                        `لا يوجد صنف لهذا الباركود"
        `
                    );
                    // setAllowKeyboard(true);
                    setIsBarcode(false);
                }

            }
            else {
                if (permistionInv?.CUSTPRICE && stor.invsType != 5) {
                    await axios
                        .get(
                            uri +
                            `RptSales/ItemsCodesCust?currCode=${itemcode}
            &&emp=${sto.empi}&&cust_id=${valueCustomers.id}&&invType=${setting.PrTy_InPr}
            &&safe=${valueSafes.id}`
                        )
                        .then((res) => {
                            defaultUnits = res.data?.unitsSub.find((x) => x.unit === res.data?.barcodes[0].unit);
                            units = res.data?.unitsSub;
                            item = res.data?.barcodes[0];
                            ibance = res.data?.balance[0]?.Qtys ?? 0;
                        })
                        .catch((err) => {
                            if (item == null) {
                            }
                        });
                    if (item != null) {
                        const newItem = localCashe.find((obj) => obj.item.barcode.toString() === item.barcode.toString());
                        if (!newItem) {
                            const addNewItem = { item: item, unit: defaultUnits, val: ibance, units: units, }
                            setLocalCashe([...localCashe, addNewItem]);
                        }
                        let totValbef = 0.0;
                        for (let m = 0; m < isdata.length; m++) {
                            if (item.curr == isdata[m].currency_from)
                                totValbef += (isdata[m].val1 * isdata[m].val);
                        };
                        let oldVal = Number(ibance) - totValbef;

                        setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
                        if (permistionInv.SIM == false &&
                            oldVal < 1 && item.ctype != 4 &&
                            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                            alert(
                                `
                الكمية المدخلة للصنف أكبر من رصيد المخزن
                الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                                }
                رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                                }
                `
                            );
                        } else {
                            await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
                        }
                        setIsBarcode(false);
                    } else {
                        alert(
                            `لا يوجد صنف لهذا الباركود"
            `
                        );
                        setRptParams({ ...rptParams, barcode: itemcode, barcodeS: itemcode, curr: {} });
                    }
                }
                else {
                    if (permistionInv?.LEVELPRICES > 0 && (stor.invsType == 0 || stor.invsType == 1)) {
                        await axios
                            .get(
                                uri +
                                `RptSales/ItemsPriceLevel?currCode=${itemcode}
          &&emp=${sto.empi}&&branch=${sto.branchi}&&invType=${setting.PrTy_InPr}
          &&safe=${valueSafes.id}&&cust_id=${valueCustomers.id}&&level=${permistionInv?.LEVELPRICES}`
                            )
                            .then((res) => {
                                defaultUnits = res.data?.unitsSub.find((x) => x.unit === res.data?.barcodes[0].unit);
                                units = res.data?.unitsSub;
                                item = res.data?.barcodes[0];
                                ibance = res.data?.balance[0].Qtys ?? 0;


                            })
                            .catch((err) => {
                                console.log(err);
                                // setAllowKeyboard(true);
                            });
                        if (item != null) {
                            const newItem = localCashe.find((obj) => obj.item.barcode.toString() === item.barcode.toString());
                            if (!newItem) {
                                const addNewItem = { item: item, unit: defaultUnits, val: ibance, units: units, }
                                setLocalCashe([...localCashe, addNewItem]);
                            }
                            let totValbef = 0.0;
                            for (let m = 0; m < isdata.length; m++) {
                                if (item.curr == isdata[m].currency_from)
                                    totValbef += (isdata[m].val1 * isdata[m].val);
                            };
                            let oldVal = Number(ibance) - totValbef;
                            setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
                            if (permistionInv.SIM == false &&
                                oldVal < 1 && item.ctype != 4 &&
                                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                                alert(
                                    `
              الكمية المدخلة للصنف أكبر من رصيد المخزن
              الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                                    }
              رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                                    }
              `
                                );
                            } else {
                                await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
                            }
                            setIsBarcode(false);
                        } else {
                            alert(
                                `لا يوجد صنف لهذا الباركود"
                `
                            );
                            setRptParams({ ...rptParams, barcode: itemcode, barcodeS: itemcode, curr: {} });
                        }
                    }
                    else {
                        await axios
                            .get(
                                uri +
                                `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}
          &&emp=${sto.empi}
          &&safe=${valueSafes.id}`
                            )
                            .then((res) => {
                                defaultUnits = res.data?.unitsSub.find((x) => x.unit === res.data?.barcodes[0].unit);
                                units = res.data?.unitsSub;
                                item = res.data?.barcodes[0];
                                ibance = res.data?.balance[0].Qtys ?? 0;
                            })
                            .catch((err) => {
                                // toast.error("لا يوجد صنف لهذا الباركود");
                                console.log(err);
                            });
                        if (item != null) {
                            const newItem = localCashe.find((obj) => obj.item.barcode.toString() === item.barcode.toString());
                            if (!newItem) {
                                const addNewItem = { item: item, unit: defaultUnits, val: ibance, units: units, }
                                setLocalCashe([...localCashe, addNewItem]);
                            }
                            let totValbef = 0.0;
                            for (let m = 0; m < isdata.length; m++) {
                                if (item.curr == isdata[m].currency_from)
                                    totValbef += (isdata[m].val1 * isdata[m].val);
                            };
                            let oldVal = Number(ibance) - totValbef;

                            setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
                            // setAllowKeyboard(true);
                            if (permistionInv.SIM == false &&
                                oldVal < 1 && item.ctype != 4 &&
                                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                                alert(
                                    `
              الكمية المدخلة للصنف أكبر من رصيد المخزن
              الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                                    }
              رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                                    }
              `
                                );
                            } else {
                                await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
                            }
                            setIsBarcode(false);
                        } else {
                            alert(
                                `لا يوجد صنف لهذا الباركود"
                `
                            );
                            setRptParams({ ...rptParams, barcode: itemcode, barcodeS: itemcode, curr: {} });
                        }
                    }

                }
            }
        }


    };

    const getcustitem = async (itemcode) => {
        let item = null;
        let ibance = 0.0;
        let units = null;
        let defaultUnits = null;
        await axios
            .get(
                uri +
                `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}
    &&emp=${sto.empi}
    &&safe=${valueSafes.id}`
            )
            .then((res) => {

                item = res.data?.barcodes[0];
                defaultUnits = res.data?.unitsSub[0];
                units = res.data?.unitsSub;
                item = res.data?.barcodes[0];
                ibance = res.data?.balance[0]?.Qtys ?? 0;
            })
            .catch((err) => {
                // toast.error("لا يوجد صنف لهذا الباركود");
                console.log(err);
            });
        if (item != null) {
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
                if (item.curr == isdata[m].currency_from)
                    totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let oldVal = Number(ibance) - totValbef;

            setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
            if (permistionInv.SIM == false &&
                oldVal < 1 &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                alert(
                    `
            الكمية المدخلة للصنف أكبر من رصيد المخزن
            الكمية الاجمالية المدخلة : ${totValbef + (parseFloat(1) * parseFloat(item?.perc))
                    }
            رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                    }
            `
                );
            } else {
                await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
            }
        } else {
            toast.error("لا يوجد صنف لهذا الباركود");
        }
    };


    const barcodeadd = (dataCode, defaultUnit, Units, Qtys) => {
        setRowUpdate({});
        let pricei = 0.0;
        let totJust = 0.0;
        let taxval = 0.0;
        let taxperc = 0.0;
        let diaperc = 0.0;
        let dismount = 0.0;
        let valperc = 0.0;
        let tot_before_vat_with_tab3val = 0.0;
        if (setting.PrTy_InPr === "22") {
            taxperc = 0.0;
            pricei = parseFloat(dataCode?.purch).toFixed(2);
        } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
            pricei = parseFloat(dataCode?.sale);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        }
        else {
            pricei = parseFloat(dataCode?.purch);
            taxperc = (parseFloat(dataCode.tax)).toFixed(2);
        };
        if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
            if (valueCustomers?.disc_perc > 0) {
                dataCode.discount = valueCustomers?.disc_perc;
                dataCode.amount_disc = 0;
            } else if (valueCustomers?.discount > 0) {
                dataCode.discount = 0;
                dataCode.amount_disc = valueCustomers?.discount;
            }
        }

        taxval = ((parseFloat(pricei) * parseFloat(dataCode.tax)) / 100).toFixed(2);
        totJust = (parseFloat(pricei)).toFixed(2);

        let i = {
            amount_disc: Number(dataCode.amount_disc),
            discount: Number(dataCode.discount),
        };
        diaperc = (parseFloat(i.discount)).toFixed(2);
        dismount = (parseFloat(i.amount_disc)).toFixed(2);
        if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
        valperc = (parseFloat(dataCode.perc)).toFixed(2);

        let errorList = [];
        let restaxvalA = 0,
            resNetA = 0,

            restotJustSumA = 0,
            restotJustAfterDiscSumA = 0,
            resDiscPerA = 0,
            resDisCountA = 0,
            tot_befor_vat_after_disc = 0;

        restotJustSumA = parseFloat(totJust);

        if (permistionInv.DSOB == true) {
            if (checked.discRateck === true) {
                //  alert('in if')
                resDiscPerA = parseFloat(invDisc.rate);
                resDisCountA = (
                    parseFloat(invDisc.rate / 100) * parseFloat(totJust)
                ).toFixed(2);

                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(resDisCountA);
            } else if (checked.discMinusck === true) {
                resDiscPerA = (
                    (parseFloat(idata.minus) / parseFloat(totJust)) *
                    100
                ).toFixed(2);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(totJust)
                ).toFixed(2);
            }

        } else {
            if (diaperc > 0) {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);
                resDiscPerA = parseFloat(diaperc);
                resDisCountA = (
                    parseFloat(diaperc / 100) * parseFloat(totJust)
                ).toFixed(2);

            } else if (dismount > 0) {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);

                let desc_perc = (
                    (dismount * 100) /
                    parseFloat(totJust)
                );
                resDiscPerA = parseFloat(desc_perc);
                resDisCountA = (
                    parseFloat(resDiscPerA / 100) * parseFloat(totJust)
                ).toFixed(2);

            } else {
                restotJustAfterDiscSumA =
                    parseFloat(totJust) - parseFloat(dismount);
                resDiscPerA = parseFloat(diaperc);
                resDisCountA = (
                    parseFloat(diaperc / 100) * parseFloat(totJust)
                ).toFixed(2);
            }

        }



        restotJustAfterDiscSumA =
            parseFloat(totJust) - parseFloat(resDisCountA);


        restaxvalA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "taxval"
        );

        tot_befor_vat_after_disc = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "before_vat"
        );
        resNetA = maths(
            parseFloat(restotJustAfterDiscSumA),
            parseFloat(taxperc),
            "Net"
        );

        if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
            tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
                parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

            let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            restaxvalA = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
        }

        dataCode = {
            /* to show */
            minPrice: dataCode.mPrice,
            PricePu: dataCode.purch,
            unitame: dataCode.unitName /*  - الـوحدة name */,
            symbol: dataCode.symbol /*  - إسم الصنف  */,
            /* to maaths */
            /* int -  الإجمالي */
            totJust: restotJustSumA,
            /* int - إجمالي الخصم بعد الخصم */
            totAfterDisc: tot_befor_vat_after_disc,

            tot_before_vat_after_d: tot_befor_vat_after_disc,
            sale_price: parseFloat(dataCode?.sale),

            tab3val_sub: tot_before_vat_with_tab3val,
            tab3Val: tot_before_vat_with_tab3val,
            /* to go */
            // currency_from: parseInt(subInfo.id), /* float - id الصنف */
            currency_from: parseInt(dataCode.curr) /* float - id الصنف */,
            unit: parseInt(dataCode.unit) /* int - الـوحدة id */,
            /* float - الكمية */
            val1: parseFloat(1),
            // new _val1:parseFloat(subInfo.new _val1),
            /* float - العبوة */
            val: parseFloat(valperc),
            // new _val:parseFloat(subInfo.perc),
            /* float - الـسعر */
            new_exchange_price: parseFloat(pricei),
            // all_new_exchange_price: parseFloat(subInfo.Price),
            /* float - الخصم  مبلغ*/
            discount: resDisCountA,
            /* float - %  خصم نسبة */
            DiscPers: resDiscPerA,
            /* float -  ضريبة القيمة المضافة نسبة */
            taxperc: parseFloat(taxperc),
            /* float - إجمالي قيمة المضافة  */
            taxval: parseFloat(restaxvalA),
            netAmountSub: parseFloat(resNetA).toFixed(2),
            barcode: dataCode.barcode /*  - الباركود */,
            sub_center: 0 /* int -  */,
            sub_branch: sto.branchi /* int - الفرع */,

            unitame: dataCode.unitName,
            sale_price: parseFloat(dataCode.sale),
            // DiscPers: parseFloat(diaperc),
            // discount: parseFloat(dataCode.amount_disc),
            discount: resDisCountA,
            DiscPers: resDiscPerA,
            taxperc: parseFloat(taxperc),
            Qtys: Qtys ?? 0,
            UnitsTable: Units,
            defUnit: defaultUnit,
            no: isdata?.length,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            type: dataCode.ctype,
        };
        if (errorList.length < 1) {
            //no error
            let add = 0;

            const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
                && obj.new_exchange_price === dataCode.new_exchange_price);

            if (permistionInv?.NOREP === true) {
                let dataToAdd = [...isdata];
                dataToAdd.push(dataCode);
                setIsData(dataToAdd);
                handSums(dataToAdd);
                setExSub(dataToAdd.length);
                add = 1;
                setRowUpdate(dataCode);
            }
            else {
                if (updateItem?.no != null) {
                    let add = 1;
                    let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
                    if (!isNaN(multiplier)) {

                        let tot = parseFloat(multiplier * updateItem.new_exchange_price);
                        let desc_mount = (
                            parseFloat(tot) *
                            (updateItem.DiscPers / 100)
                        );
                        let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

                        let taxMount = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "taxval"
                        );
                        let betTax = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "before_vat"
                        );

                        let resNetA = maths(
                            parseFloat(totBe),
                            parseFloat(updateItem.taxperc),
                            "Net"
                        );

                        if (parseFloat(updateItem?.tab3val_sub) > 0 && permistionInv?.USETOBACO) {
                            let tot_before_new = maths(
                                parseFloat(pricei),
                                parseFloat(updateItem.taxperc),
                                "before_vat"
                            );
                            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

                            let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                            taxMount = mathsTab3val(
                                parseFloat(tot_before),
                                parseFloat(updateItem.taxperc),
                                "taxval"
                            );

                            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                                + parseFloat(taxMount)).toFixed(2);
                        }
                        const newData = {
                            ...updateItem,
                            val1: multiplier,
                            totJust: tot,
                            totAfterDisc: betTax,
                            taxval: taxMount,
                            netAmountSub: resNetA,
                            discount: desc_mount,
                            tab3val_sub: tot_before_vat_with_tab3val,
                            tab3Val: tot_before_vat_with_tab3val,
                        };

                        const index = updateItem?.no;
                        const dataUpdate = [...isdata];
                        dataUpdate[index] = { ...newData };
                        setIsData([...dataUpdate]);
                        handSums(dataUpdate);
                        setRowUpdate(updateItem);
                    }
                } else {
                    let dataToAdd = [...isdata];
                    dataToAdd.push(dataCode);
                    setIsData(dataToAdd);
                    handSums(dataToAdd);
                    setExSub(dataToAdd.length);
                    add = 1;
                    setRowUpdate(dataCode);
                }
            }
        } else {
            // resolve();
        }
        if (permistionInv?.SHOW_UNITS && dataCode?.UnitsTable?.length > 0) {
            setSelectUnit(dataCode?.UnitsTable[0]);
        }
    };

    const searchTimeout = useRef(null);
    const handleInputSearchCust = (event, newValue, reason) => {
        handleInputSearchCustomers(newValue, AutoOptions.Customers, searchTimeout, setOptionsCustomers, countCustomers,
            setting.cusType, false, setSearchCustText, reason)
    };
    const handleIconSearchCust = () => {
        if (countCustomers && searchCustText !== "" || searchCustText !== null) {
            viewHandleCustomers(searchCustText, setOptionsCustomers, false, setting.cusType, -1, AutoOptions.Customers);
        }
    };
    const elmntBtn = (title, icondiv) => {
        return (
            <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                disabled={true}
                startIcon={icondiv}
            >
                {" "}
                {title}
            </Button>
        );
    };

    const elmntIcon = (icondiv, dis) => {
        return (
            <Fab
                size="medium"
                color="primary"
                disabled={dis}
                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
            >
                {icondiv}
            </Fab>
        );
    };

    const styBtn = {
        dis: { color: "#3b773d", background: "#4fa152" },
        undis: { color: "#fff" },
    };
    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };

    const handCSnack = (event, reason) => {
        setSnack({ ...snack, openSnak: false });
    };

    const frontSnack = () => {
        return (
            <div className={clasSN.rootSN}>
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={openSnak}
                    autoHideDuration={snack.time}
                    onClose={handCSnack}
                    key={vertical + horizontal}
                    className={clasSN.snackbarSN}
                >
                    <Alert onClose={handCSnack} severity={snack.severit}>
                        {" "}
                        {snack.text}{" "}
                    </Alert>
                </Snackbar>
            </div>
        );
    };
    const frontAppBar = () => {
        return (
            <RestAppBar {...{
                AutoOptions,
                idata,
                backHome,
                handOpenDw,
                isHedden,
                permistionInv,
                style,
                stElemnt,
                clasBA,
                transForm,
                handOpenDwt,
                handNewInv,
                TransitionDown,
                styBtn,
                toWhere,
                loading,
                buttonClassnameSave,
                success,
                clasCAB,
                or,
                buttonClassnamePrint,
                clickCloseToggle,
                toPrint,
                toggle,
                isOpenUpdate,
                elmntBtn,
                clickUpdate,
                generating,
                toPrintCashOrNetwork,
                valueType,
                transformDone,
                stor,
                sendToZatca,
                elmntIcon,
                clickOpenToggle,
                deleteTos,
                uiElement,
                buttonClassnameDelete,
                isSavingRef
            }}
            />

        );
    };

    const topPart = () => {
        return (
            <RestHeader {...{
                AutoOptions,
                isPurches,
                setting,
                handleOpenCustomer,
                changAutoCustomers
                , optionsCustomers,
                changAutoSalesMen,
                valueSalesmen,
                changAutoCostcenter,
                valueCostcenter,
                idata,
                changAutoType,
                valueType,
                valueSafes,
                changAutoSafes,
                changAutoStock,
                valueStock,
                changAutoBank,
                valueBank,
                changSwitch,
                uiElement,
                switchState,
                lbl,
                claslbl,
                gets,
                onChangeSearch,
                handleFocus,
                onChangeData,
                rptParams,
                setShowPaid,
                exsub,
                handClickInvs,
                infoInv,
                changIdata,
                showPaid,
                clasCAB,
                changInvs,
                loading,
                toWhere,
                buttonClassnameSavetmp,
                SaleCheckbox,
                valueCustomers,
                maxShifts,
                isStock,
                isMake,
                inputRef,
                isHedden,
                getCustomerData,
                transForm,
                selectOrderType,
                orderData,
                changeOrderType,
                maxOrderNo,
                permistionInv,
                localCashe,
                getBarcodeMezan,
                getBarcodeMulti,
                isdata,
                barcodeadd,
                setRptParams,
                handleInputSearchCust,
                handleIconSearchCust,
                searchCustText,
                setOpenTawla,
                getCodeDiscount
            }}
            />

        );
    };
    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    };
    useEffect(() => {
        if (isMobileDevice()) return;

        const handleKeyDown = async (event) => {
            if (event.ctrlKey && event.key === "u") {
                if (or.postput == "toPut" && isHedden == true) {
                    event.preventDefault();
                    setIshedden(false)
                }
            }

        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isHedden, or]);


    useEffect(() => {
        if (isMobileDevice()) return;
        if (isLoading) return;

        const handleKeyDown = async (event) => {
            if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
            ) return;
            if (event.key === 'F3') {

                event.preventDefault();

                or.PrAC = 3;
                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: "يجب تنزيل اصناف",
                        time: 2000,
                    });
                } else {
                    await toWhere("print", "e");
                }

            }
            if (event.key === 'F10') {

                //if (event.altKey && event.key ==="s"){
                event.preventDefault();
                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: "يجب تنزيل اصناف",
                        time: 2000,
                    });
                } else {
                    await toWhere("save", "e");
                }

            }
            if (event.key === 'F11') {
                event.preventDefault();
                or.PrAC = 2;

                if (isdata.length == 0) {
                    handOSnack({
                        vertical: "top",
                        horizontal: "center",
                        severit: "warning",
                        text: "يجب تنزيل اصناف",
                        time: 2000,
                    });
                } else {
                    await toWhere("print", "e");
                }

            }
            if (event.altKey && event.key === "z") {
                event.preventDefault();
                await openDrawer();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, [idata, isdata, remains, payment, or, isLoading]);

    useEffect(() => {

        if (isMobileDevice()) return;
        if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
        ) return;
        const handleKeyDown = async (event) => {
            if (event.key === 'F6') {
                if (or.postput == "toPut" && permistionInv.Up) {
                    event.preventDefault();
                    let balanceItems = null;
                    const tb = {
                        wait: true,
                        checksItems: true,
                        parms: {
                            safe: valueSafes?.id,
                            branch: sto.branchi,
                            _Data: isdata,
                        },
                    };

                    axios
                        .post(uri + "GetD", tb)
                        .then((res) => {
                            balanceItems = isdata.map((sub) => {
                                const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                                let valQuantity = (parseFloat(blncData?.Qtys ?? 0) + parseFloat(sub?.val1 * sub?.val)).toFixed(2);
                                return {
                                    ...sub,
                                    Qtys: setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11" ?
                                        valQuantity : blncData?.Qtys ?? 0,
                                    PricePu: blncData.avgCost,
                                    minPrice: blncData.avgCost,
                                };
                            });
                            setIsData([...balanceItems]);
                            setIshedden(false);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
            if (event.ctrlKey && event.key === "u") {

                if (or.postput == "toPut" && permistionInv.Up) {
                    event.preventDefault();
                    let balanceItems = null;
                    const tb = {
                        wait: true,
                        checksItems: true,
                        parms: {
                            safe: valueSafes?.id,
                            branch: sto.branchi,
                            _Data: isdata,
                        },
                    };

                    axios
                        .post(uri + "GetD", tb)
                        .then((res) => {
                            balanceItems = isdata.map((sub) => {
                                const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                                return {
                                    ...sub,
                                    Qtys: blncData?.Qtys ?? 0,
                                    PricePu: blncData.avgCost,
                                    minPrice: blncData.avgCost,
                                };
                            });
                            setIsData([...balanceItems]);
                            setIshedden(false);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isHedden, isdata, or, AutoOptions, setting]);



    useEffect(() => {
        if (setting.PrTy_InPr == "12" || setting.PrTy_InPr == "11") {
            setIshedden(true);
        }
    }, [setting, isHedden]);

    const stylRo = {
        BorderBottom: "solid 0.5px",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000",
        minHeight: 150,
        paddingBottom: "11px",
        paddingTop: "11px"
    }

    const frontUp = () => {
        return (
            <div className={clasBA.continarBAInv} style={{ backgroundColor: colors.green[50] }}>
                <React.Fragment
                >
                    <CssBaseline />
                    <Grid container lg={12} md={12} sm={12} xs={12}>
                        <Grid item lg={3} md={4} sm={4} xs={12} style={{ direction: "rtl" }}>
                            <Grid item container className={clasup.rootupRest}>
                                <Grid item lg={2} md={2} sm={2} xs={2}   >
                                    <TableContainer component={Paper} >
                                        <Table
                                            size="small" aria-label="a dense table" className="my-table" >
                                            <TableBody
                                                style={{ direction: "rtl" }}
                                            >
                                                {SelectNumber.map((row) => (
                                                    <TableRow key={row.name}
                                                        style={{
                                                            textAlign: "right",
                                                            whiteSpace: "nowrap",
                                                            color: "#000",
                                                            backgroundColor: colors.grey[300],
                                                            fontWeight: "bold",
                                                            fontFamily: "Amiri-Regular",
                                                            fontSize: 15,
                                                            border: "solid 0.6px",
                                                        }}
                                                    >
                                                        <TableCell style={stylRo} align="center" onClick={() => { onSelectNumber(row); }}>{row.name}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid container item lg={10} md={10} sm={10} xs={10} >
                                    <Grid container lg={12} md={12} sm={12} xs={12}>
                                        {rowUpdate?.UnitsTable?.length > 1 && permistionInv?.SHOW_UNITS &&
                                            <UnitsFilters {...{
                                                selectUnit,
                                                rowUpdate,
                                                changAutoCurrUnits
                                            }} />}
                                        <InvoiceRestTable {...{
                                            isdata, setIsData, maths, handSums, isPurches, isStock,
                                            isMake, permistionInv, handOSnack, setting, setConfirmDialog, isHedden,
                                            or, isOpenUpdate, rowUpdate, setRowUpdate, mathsTab3val, frontFootr
                                        }}
                                        />
                                        {frontFootr()}
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item lg={9} md={8} sm={8} xs={12} >
                            <Hidden smDown={["sm"]}>
                                {fromInv ?
                                    <RestProductsG dataTable={isdata} groups={AutoOptions.groups}
                                        groupsSub={AutoOptions.groupsSub} permistionInv={permistionInv}
                                        valueSafes={valueSafes} onSelectItem={onSelectRest}
                                        localCasheItems={localCasheItems} setLocalCasheItems={setLocalCasheItems} /> :
                                    <ProductsGroups dataTable={isdata} groups={AutoOptions.groups}
                                        groupsSub={AutoOptions.groupsSub} permistionInv={permistionInv}
                                        valueSafes={valueSafes} onSelectItem={onSelectRest}
                                        localCasheItems={localCasheItems} setLocalCasheItems={setLocalCasheItems} />}
                            </Hidden>
                            <Hidden mdUp={['md']}>
                                <ProductsGroups dataTable={isdata ?? []} groups={AutoOptions.groups}
                                    groupsSub={AutoOptions.groupsSub} permistionInv={permistionInv}
                                    valueSafes={valueSafes} onSelectItem={onSelectRest}
                                    localCasheItems={localCasheItems} setLocalCasheItems={setLocalCasheItems} />
                            </Hidden>

                        </Grid>
                    </Grid>
                </React.Fragment>
            </div>
        );
    };
    function ScrollTop(props) {
        const { children, window } = props;
        const trigger = useScrollTrigger({
            target: window ? window() : undefined,
            disableHysteresis: true,
            threshold: 100,
        });

        const handUp = (event) => {
            const anchor = (event.target.ownerDocument || document).querySelector(
                "#back-to-top-anchor"
            );
            if (anchor) {
                anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        };

        return (
            <Zoom in={trigger}>
                <div onClick={handUp} role="presentation" className={clasFu.root}>
                    {children}
                </div>
            </Zoom>
        );
    }
    ScrollTop.propTypes = {
        children: PropTypes.element.isRequired,
        window: PropTypes.func,
    };
    const frontInvst = () => {
        return (
            <OutstandingInvoice
                {...{
                    AutoOptions,
                    showChosedInvt,
                    setting,
                    isPurches,
                    isStock,
                    outstandData,
                    setOutstandData
                }}
            />
        );
    };



    const [scroll, setScroll] = React.useState("paper");

    const frontFootr = () => {
        return (
            <RestFooter {...{
                isPurches,
                setting,
                idata,
                valueType,
                uiElement,
                isStock,
                permistionInv,
                changinvDisc,
                invDisc,
                changClick,
                payment,
                changPayment,
                isHedden,
            }}
            />

        );
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    if (!isApiConnect) return <ReConnect />;

    return showSc ? (
        <BackdropScI />
    ) : (
        <>
            <div
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }} >
                <Typography
                    component="div"
                    style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
                >
                    <Grid
                        container
                        justifyContent="center"
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                    >
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div style={{ backgroundColor: "fff" }}>
                                <AppBar position="static" style={{ padding: 0, backgroundColor: "fff" }}  >
                                    <Tabs
                                        style={{
                                            backgroundColor: isPurches ? colors.blue[50] : colors.green[50],
                                            textAlign: "center",
                                            fontSize: 20,
                                            width: "100%",
                                            height: "100vh",
                                            direction: "rtl",
                                            overflowY: 'auto', height: 10
                                        }}
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="simple tabs example"
                                    >
                                        <Tab
                                            onDoubleClick={(event) => clickUpdate()}
                                            style={{ fontWeight: "bold", color: "#000" }} label={setting.PrTy_InPr === "02" ? transForm('sales_invoice') : setting.PrTy_InPr === "12" ? transForm('return_sales')
                                                : setting.PrTy_InPr === "01" ? transForm('purchase_invoice') : setting.PrTy_InPr === "11" ? transForm('return_purchase') :
                                                    setting.PrTy_InPr === "03" ? transForm("quotation") : setting.PrTy_InPr === "04" ? transForm("purchase_order") :
                                                        setting.PrTy_InPr === "22" ? transForm("first_stock") : setting.PrTy_InPr === "33" ? transForm("made_Order") : setting.titleHed}
                                            {...a11yProps(0)} />
                                        {permistionInv?.Se &&
                                            (
                                                <Tab style={{ fontWeight: "bold", color: "#000" }} label={transForm("invoice-search")}{...a11yProps(1)} />
                                            )}
                                        {/* <Tab style={{ fontWeight: "bold", color: "#000" }} label={transForm("invoice-search")}{...a11yProps(1)} /> */}
                                        <Tab style={{ fontWeight: "bold", color: "#000" }} label={transForm("out-billing")}{...a11yProps(2)} />
                                    </Tabs>
                                </AppBar>

                                <TabPanel value={value} index={0} keepMounted>
                                    <div
                                        style={{ direction: i18next.language == "ar" ? "ltr" : "rtl" }}
                                    >
                                        {/* s Fixed */}
                                        {frontSnack()}
                                        {frontAppBar()}
                                        {/* e Fixed */}
                                        {/* s UP */}
                                        {topPart()}
                                        {frontUp()}
                                        {/* {frontInvs()} */}
                                        {/* e DW */}
                                        {/* s DW */}
                                        {/* {frontInvst()} */}
                                        {/* s currFavD */}
                                        {/* {CurrFavorite()} e currFavD */}
                                        {/* s PMD */}
                                        {/* {frontPMDialog()} */}

                                        {
                                            allow.c ? (
                                                <CustomersDialog
                                                    open={isOpenCustomer}
                                                    type={location.state.setting.cusType}
                                                    onClose={() => {
                                                        setIsOpenCustomer(false);
                                                        // reloadGet();
                                                    }}
                                                    onSave={(custData) => {
                                                        setIsOpenCustomer(false);
                                                        reLoadCust(custData);
                                                    }}

                                                />
                                            ) : null}

                                        {
                                            allow.cud ? (
                                                <CustomerDialogData
                                                    open={isOpenCustomerData}
                                                    type={location.state.setting.cusType}
                                                    onClose={() => {
                                                        setIsOpenCustomerData(false);
                                                        // reloadGet();
                                                    }}
                                                    onSave={(updateData) => {
                                                        setIsOpenCustomerData(false);
                                                        reUpdateCust(updateData);
                                                    }}
                                                    custData={custData}
                                                />
                                            ) : null}
                                        {allow.s ? (
                                            <ItemsDialog
                                                DialogOpened={isOpenSy}
                                                DialogClose={() => {
                                                    setIsOpenSy(false);
                                                    setAllow({ ...allow, s: false });
                                                }}
                                                locats={{ state: storS }}
                                            />
                                        ) : null}
                                        {openTawla ?
                                            <GetTawla openTawla={openTawla} setOpenTawla={setOpenTawla} idata={idata}
                                                setIData={setIData} tawlaGroups={tawlaGroups} setTawlaGroups={setTawlaGroups} /> : null}

                                        {voucherDialog.isOpen && (
                                            <ExtVoucherDialog
                                                voucherDialog={voucherDialog}
                                                setVoucherDialog={setVoucherDialog}
                                            />
                                        )}
                                        {openPrint.open &&
                                            <InvoiceTypePrintA4 isFocus={true} openPrint={openPrint} handNewInv={handNewInv}
                                                keepFocus={keepFocus} foundData={foundData} setFoundData={setFoundData} />}
                                        {openPMD &&
                                            <PaidWindowForm
                                                {... {
                                                    idata,
                                                    invDisc,
                                                    remains,
                                                    setRemains,
                                                    payment,
                                                    changPayment,
                                                    buttonClassnameSavePMD,
                                                    toDB,
                                                    restPM,
                                                    loading,
                                                    handClosePMD,
                                                    style,
                                                    changClick,
                                                    changinvDisc,
                                                    gets,
                                                    openPMD,
                                                    valueEmployePMD,
                                                    uiElement,
                                                    changChcked,
                                                    transition,
                                                    checked,
                                                    clasAo,
                                                    valueBankPMD,
                                                    changAutoBankPMD,
                                                    changIdata,
                                                    changAutoEmployee,
                                                    valueBankTransPMD,
                                                    changAutoBank2,
                                                    typePress,
                                                    valueType,
                                                    AutoOptions,
                                                    permistionInv
                                                }}
                                            />}

                                    </div>
                                </TabPanel>

                                {permistionInv?.Se &&
                                    (
                                        <TabPanel value={value} index={1} keepMounted>
                                            <SearchInvoiceScreean
                                                {...{
                                                    openDw,
                                                    handCloseDw,
                                                    transition,
                                                    showChosedInv,
                                                    invsShow,
                                                    stElemnt,
                                                    style,
                                                    valueTypeFltr,
                                                    gets,
                                                    searchedInvShow,
                                                    setOr,
                                                    or,
                                                    optionsCustomers,
                                                    PcIdIvPc: setting.PrTy_InPr,
                                                    setting,
                                                    setIsClick,
                                                    ished,
                                                    AutoOptions,
                                                    isHedden,
                                                    permistionInv,
                                                    setIshedden,
                                                    isStock,
                                                    isMake,
                                                    isPurches,
                                                    invsSearchTable,
                                                    setInvsSearchTable,
                                                    setValue,
                                                    rptParamsSearch,
                                                    setRptParamsSearch
                                                }}
                                            />
                                        </TabPanel>
                                    )}


                                <TabPanel value={value} index={!permistionInv?.Se ? 1 : 2} keepMounted>
                                    {frontInvst()}
                                </TabPanel>

                            </div>
                        </Grid>
                    </Grid>

                </Typography>
            </div>
        </>

    );
}
